webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// The browser platform with a compiler
	// Application is using dynamic bootstrapping wit JIT (Just-In-Time) compiler
	var platform_browser_dynamic_1 = __webpack_require__(1);
	// The app module
	var AppModule_1 = __webpack_require__(23);
	// Combine and launch the module
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(AppModule_1.AppModule);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var shared_1 = __webpack_require__(24);
	var core_2 = __webpack_require__(68);
	var admin_1 = __webpack_require__(220);
	var SessionService_1 = __webpack_require__(123);
	var LocalNetworkService_1 = __webpack_require__(102);
	var AppComponent_1 = __webpack_require__(229);
	var AppRouting_1 = __webpack_require__(245);
	var NavigateComponent_1 = __webpack_require__(246);
	var UserService_1 = __webpack_require__(110);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    return AppModule;
	}());
	AppModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            platform_browser_1.BrowserModule,
	            core_2.CoreModule,
	            shared_1.SharedModule,
	            admin_1.AdminModule,
	            AppRouting_1.routing,
	        ],
	        declarations: [
	            AppComponent_1.AppComponent,
	            NavigateComponent_1.NavigateComponent
	        ],
	        providers: [
	            SessionService_1.SessionService,
	            LocalNetworkService_1.LocalNetworkService,
	            UserService_1.UserService
	        ],
	        bootstrap: [
	            AppComponent_1.AppComponent,
	        ]
	    })
	], AppModule);
	exports.AppModule = AppModule;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(25));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var forms_1 = __webpack_require__(26);
	var http_1 = __webpack_require__(30);
	var components_1 = __webpack_require__(31);
	var core_2 = __webpack_require__(38);
	// AoT requires an exported function for factories
	var SharedModule = (function () {
	    /**
	     * The SharedModule which will define the modules, components & directives that will
	     * be used again in other feature modules. It 's different with the CoreModule which
	     * will define the components, directives that only use one time in the main AppModule.
	     */
	    function SharedModule() {
	    }
	    return SharedModule;
	}());
	SharedModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            common_1.CommonModule,
	            forms_1.FormsModule,
	            http_1.HttpModule,
	            http_1.JsonpModule,
	            core_2.TranslateModule,
	        ],
	        declarations: [
	            components_1.AlertBoxComponent,
	            components_1.PaginatorComponent,
	        ],
	        exports: [
	            // Modules
	            common_1.CommonModule,
	            forms_1.FormsModule,
	            http_1.HttpModule,
	            http_1.JsonpModule,
	            // Components
	            components_1.AlertBoxComponent,
	            components_1.PaginatorComponent,
	            core_2.TranslateModule,
	        ]
	    })
	    /**
	     * The SharedModule which will define the modules, components & directives that will
	     * be used again in other feature modules. It 's different with the CoreModule which
	     * will define the components, directives that only use one time in the main AppModule.
	     */
	], SharedModule);
	exports.SharedModule = SharedModule;


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(32));
	__export(__webpack_require__(35));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var AlertBoxComponent = (function () {
	    function AlertBoxComponent() {
	    }
	    AlertBoxComponent.prototype.ngOnInit = function () {
	        // Set default message type if no type input received.
	        if (!this.type) {
	            this.type = "warning";
	        }
	    };
	    AlertBoxComponent.prototype.onClose = function () {
	        // Set message to "" to hide the box.
	        this.message = "";
	    };
	    return AlertBoxComponent;
	}());
	__decorate([
	    core_1.Input('message'),
	    __metadata("design:type", String)
	], AlertBoxComponent.prototype, "message", void 0);
	__decorate([
	    core_1.Input('type'),
	    __metadata("design:type", String)
	], AlertBoxComponent.prototype, "type", void 0);
	AlertBoxComponent = __decorate([
	    core_1.Component({
	        selector: 'alert-box',
	        template: __webpack_require__(33),
	        styles: [__webpack_require__(34)]
	    }),
	    core_1.Injectable()
	], AlertBoxComponent);
	exports.AlertBoxComponent = AlertBoxComponent;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"callout\" [ngClass]=\"type\" [class.hidden]=\"!message\">\n    {{message}}\n    <button class=\"close-button\" type=\"button\" (click)=\"onClose()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>";

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = ".callout{padding:0.5rem 1.5rem 0.5rem 0.5rem;opacity:1;visibility:visible;transition:all ease-in-out 0.2s}.callout.hidden{visibility:hidden;opacity:0;padding:0;margin:0}.callout button.close-button{right:0.5rem;line-height:0.7}\n"

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var PaginatorComponent = (function () {
	    function PaginatorComponent() {
	        this.currentPageUpdated = new core_1.EventEmitter();
	    }
	    PaginatorComponent.prototype.ngOnInit = function () {
	        if (this.currentPage > this.totalPage) {
	            this.currentPage = 1;
	        }
	        this.oldTotalPage = this.totalPage;
	        // Generate page number range list that will be used to display.
	        this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	    };
	    PaginatorComponent.prototype.ngOnChanges = function (changes) {
	        for (var propName in changes) {
	            if (propName === 'totalPage' && changes[propName].currentValue > 0) {
	                // Re-generate page number range list that will be used to display.
	                this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	            }
	            if (propName === 'currentPage') {
	                if (this.pageList && this.pageList.indexOf(changes[propName].currentValue) === -1) {
	                    // Re-generate page number range list that will be used to display.
	                    this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	                }
	            }
	        }
	    };
	    PaginatorComponent.prototype.generatePageNumberList = function (numberDisplay, currentPage, totalPage) {
	        var pageNumberList = [];
	        var range = Math.floor(numberDisplay / 2);
	        var start = 0;
	        var end = currentPage + range > totalPage ? totalPage : currentPage + range;
	        // Generate start number
	        if (currentPage - range > 0) {
	            start = currentPage + range > totalPage ? totalPage - numberDisplay + 1 : currentPage - range;
	            start = start < 1 ? start = 1 : start;
	        }
	        else {
	            start = 1;
	        }
	        // Generate end number
	        end = start + numberDisplay - 1 > totalPage ? totalPage : start + numberDisplay - 1;
	        for (start; start <= end; start++) {
	            pageNumberList.push(start);
	        }
	        return pageNumberList;
	    };
	    PaginatorComponent.prototype.updateSelectedPage = function (page) {
	        if (page > 0 && page <= this.totalPage) {
	            // Update current Page
	            this.currentPage = page;
	            // generate new page list
	            this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	            // Fire event for parent component to know current page had been changed
	            this.currentPageUpdated.emit(page);
	        }
	    };
	    return PaginatorComponent;
	}());
	__decorate([
	    core_1.Input('currentPage'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "currentPage", void 0);
	__decorate([
	    core_1.Input('totalPage'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "totalPage", void 0);
	__decorate([
	    core_1.Input('numberDisplay'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "numberDisplay", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], PaginatorComponent.prototype, "currentPageUpdated", void 0);
	PaginatorComponent = __decorate([
	    core_1.Component({
	        selector: 'pagination',
	        template: __webpack_require__(36),
	        styles: [__webpack_require__(37)]
	    }),
	    core_1.Injectable()
	], PaginatorComponent);
	exports.PaginatorComponent = PaginatorComponent;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"text-center\" *ngIf=\"totalPage>1\">\n    <ul class=\"paginator\">\n        <!-- First Page -->\n        <li [class.disabled]=\"currentPage === 1\" title=\"First page\" (click)=\"updateSelectedPage(1)\">\n            <i class=\"material-icons\">first_page</i>\n        </li>\n        <!-- Previous Page -->\n        <li [class.disabled]=\"currentPage === 1\" title=\"Previous page\" (click)=\"updateSelectedPage(currentPage - 1)\">\n            <i class=\"material-icons\">keyboard_arrow_left</i>\n        </li>\n        <!-- Pages -->\n        <li *ngFor=\"let page of pageList\" [class.current]=\"page === currentPage\" (click)=\"updateSelectedPage(page)\">\n            {{page}}\n        </li>\n        \n        <!-- Next Page -->\n        <li title=\"Next page\" (click)=\"updateSelectedPage(currentPage + 1)\" [class.disabled]=\"currentPage === totalPage\">\n            <i class=\"material-icons\">keyboard_arrow_right</i>\n        </li>\n        <!-- Last Page -->\n        <li title=\"Last page\" (click)=\"updateSelectedPage(totalPage)\" [class.disabled]=\"currentPage === totalPage\">\n            <i class=\"material-icons\">last_page</i>\n        </li>\n    </ul>\n</div>";

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = "ul.paginator{display:inline-flex;display:-webkit-inline-flex;margin:1rem}ul.paginator li{margin:0 0.2rem;border:1px #00707e solid;border-radius:0.2rem;padding:0.2rem;vertical-align:middle;display:inline-block;color:#00707e;text-align:center;width:2rem;cursor:pointer}ul.paginator li.disabled{opacity:0.25;cursor:not-allowed}ul.paginator li:not(.disabled):hover{background-color:#00707e;color:#fff}ul.paginator li.current{background-color:#00707e;color:#fff;cursor:default}\n"

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(3), __webpack_require__(7), __webpack_require__(39), __webpack_require__(45), __webpack_require__(53), __webpack_require__(55), __webpack_require__(57), __webpack_require__(61), __webpack_require__(63), __webpack_require__(66));
		else if(typeof define === 'function' && define.amd)
			define(["@angular/core", "rxjs/Observable", "rxjs/add/observable/of", "rxjs/add/operator/concat", "rxjs/add/operator/map", "rxjs/add/operator/merge", "rxjs/add/operator/share", "rxjs/add/operator/switchMap", "rxjs/add/operator/take", "rxjs/add/operator/toArray"], factory);
		else if(typeof exports === 'object')
			exports["ngx-translate-core"] = factory(require("@angular/core"), require("rxjs/Observable"), require("rxjs/add/observable/of"), require("rxjs/add/operator/concat"), require("rxjs/add/operator/map"), require("rxjs/add/operator/merge"), require("rxjs/add/operator/share"), require("rxjs/add/operator/switchMap"), require("rxjs/add/operator/take"), require("rxjs/add/operator/toArray"));
		else
			root["ngx-translate-core"] = factory(root["@angular/core"], root["rxjs/Observable"], root["rxjs/add/observable/of"], root["rxjs/add/operator/concat"], root["rxjs/add/operator/map"], root["rxjs/add/operator/merge"], root["rxjs/add/operator/share"], root["rxjs/add/operator/switchMap"], root["rxjs/add/operator/take"], root["rxjs/add/operator/toArray"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_19__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 11);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USE_STORE; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USE_DEFAULT_LANG; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TranslateService; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_of__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_of__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_concat__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_concat__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_share__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_share__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_merge__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_merge__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_switchMap__ = __webpack_require__(17);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_switchMap__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_toArray__ = __webpack_require__(19);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_toArray__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_take__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_take__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__translate_store__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__translate_loader__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translate_compiler__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__missing_translation_handler__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__translate_parser__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util__ = __webpack_require__(6);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var USE_STORE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('USE_STORE');
	var USE_DEFAULT_LANG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('USE_DEFAULT_LANG');
	var TranslateService = (function () {
	    /**
	     *
	     * @param store an instance of the store (that is supposed to be unique)
	     * @param currentLoader An instance of the loader currently used
	     * @param compiler An instance of the compiler currently used
	     * @param parser An instance of the parser currently used
	     * @param missingTranslationHandler A handler for missing translations.
	     * @param isolate whether this service should use the store or not
	     * @param useDefaultLang whether we should use default language translation when current language translation is missing.
	     */
	    function TranslateService(store, currentLoader, compiler, parser, missingTranslationHandler, useDefaultLang, isolate) {
	        if (useDefaultLang === void 0) { useDefaultLang = true; }
	        if (isolate === void 0) { isolate = false; }
	        this.store = store;
	        this.currentLoader = currentLoader;
	        this.compiler = compiler;
	        this.parser = parser;
	        this.missingTranslationHandler = missingTranslationHandler;
	        this.useDefaultLang = useDefaultLang;
	        this.isolate = isolate;
	        this.pending = false;
	        this._onTranslationChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._onLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._onDefaultLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._langs = [];
	        this._translations = {};
	        this._translationRequests = {};
	    }
	    Object.defineProperty(TranslateService.prototype, "onTranslationChange", {
	        /**
	         * An EventEmitter to listen to translation change events
	         * onTranslationChange.subscribe((params: TranslationChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<TranslationChangeEvent>}
	         */
	        get: function () {
	            return this.isolate ? this._onTranslationChange : this.store.onTranslationChange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "onLangChange", {
	        /**
	         * An EventEmitter to listen to lang change events
	         * onLangChange.subscribe((params: LangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<LangChangeEvent>}
	         */
	        get: function () {
	            return this.isolate ? this._onLangChange : this.store.onLangChange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "onDefaultLangChange", {
	        /**
	         * An EventEmitter to listen to default lang change events
	         * onDefaultLangChange.subscribe((params: DefaultLangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<DefaultLangChangeEvent>}
	         */
	        get: function () {
	            return this.isolate ? this._onDefaultLangChange : this.store.onDefaultLangChange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "defaultLang", {
	        /**
	         * The default lang to fallback when translations are missing on the current lang
	         */
	        get: function () {
	            return this.isolate ? this._defaultLang : this.store.defaultLang;
	        },
	        set: function (defaultLang) {
	            if (this.isolate) {
	                this._defaultLang = defaultLang;
	            }
	            else {
	                this.store.defaultLang = defaultLang;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "currentLang", {
	        /**
	         * The lang currently used
	         * @type {string}
	         */
	        get: function () {
	            return this.isolate ? this._currentLang : this.store.currentLang;
	        },
	        set: function (currentLang) {
	            if (this.isolate) {
	                this._currentLang = currentLang;
	            }
	            else {
	                this.store.currentLang = currentLang;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "langs", {
	        /**
	         * an array of langs
	         * @type {Array}
	         */
	        get: function () {
	            return this.isolate ? this._langs : this.store.langs;
	        },
	        set: function (langs) {
	            if (this.isolate) {
	                this._langs = langs;
	            }
	            else {
	                this.store.langs = langs;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "translations", {
	        /**
	         * a list of translations per lang
	         * @type {{}}
	         */
	        get: function () {
	            return this.isolate ? this._translations : this.store.translations;
	        },
	        set: function (translations) {
	            if (this.isolate) {
	                this._currentLang = translations;
	            }
	            else {
	                this.store.translations = translations;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Sets the default language to use as a fallback
	     * @param lang
	     */
	    TranslateService.prototype.setDefaultLang = function (lang) {
	        var _this = this;
	        if (lang === this.defaultLang) {
	            return;
	        }
	        var pending = this.retrieveTranslations(lang);
	        if (typeof pending !== "undefined") {
	            // on init set the defaultLang immediately
	            if (!this.defaultLang) {
	                this.defaultLang = lang;
	            }
	            pending.take(1)
	                .subscribe(function (res) {
	                _this.changeDefaultLang(lang);
	            });
	        }
	        else {
	            this.changeDefaultLang(lang);
	        }
	    };
	    /**
	     * Gets the default language used
	     * @returns string
	     */
	    TranslateService.prototype.getDefaultLang = function () {
	        return this.defaultLang;
	    };
	    /**
	     * Changes the lang currently used
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.use = function (lang) {
	        var _this = this;
	        // don't change the language if the language given is already selected
	        if (lang === this.currentLang) {
	            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(this.translations[lang]);
	        }
	        var pending = this.retrieveTranslations(lang);
	        if (typeof pending !== "undefined") {
	            // on init set the currentLang immediately
	            if (!this.currentLang) {
	                this.currentLang = lang;
	            }
	            pending.take(1)
	                .subscribe(function (res) {
	                _this.changeLang(lang);
	            });
	            return pending;
	        }
	        else {
	            this.changeLang(lang);
	            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(this.translations[lang]);
	        }
	    };
	    /**
	     * Retrieves the given translations
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.retrieveTranslations = function (lang) {
	        var pending;
	        // if this language is unavailable, ask for it
	        if (typeof this.translations[lang] === "undefined") {
	            this._translationRequests[lang] = this._translationRequests[lang] || this.getTranslation(lang);
	            pending = this._translationRequests[lang];
	        }
	        return pending;
	    };
	    /**
	     * Gets an object of translations for a given language with the current loader
	     * and passes it through the compiler
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.getTranslation = function (lang) {
	        var _this = this;
	        this.pending = true;
	        this.loadingTranslations = this.currentLoader.getTranslation(lang).share();
	        this.loadingTranslations.take(1)
	            .subscribe(function (res) {
	            _this.translations[lang] = _this.compiler.compileTranslations(res, lang);
	            _this.updateLangs();
	            _this.pending = false;
	        }, function (err) {
	            _this.pending = false;
	        });
	        return this.loadingTranslations;
	    };
	    /**
	     * Manually sets an object of translations for a given language
	     * after passing it through the compiler
	     * @param lang
	     * @param translations
	     * @param shouldMerge
	     */
	    TranslateService.prototype.setTranslation = function (lang, translations, shouldMerge) {
	        if (shouldMerge === void 0) { shouldMerge = false; }
	        translations = this.compiler.compileTranslations(translations, lang);
	        if (shouldMerge && this.translations[lang]) {
	            this.translations[lang] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["c" /* mergeDeep */])(this.translations[lang], translations);
	        }
	        else {
	            this.translations[lang] = translations;
	        }
	        this.updateLangs();
	        this.onTranslationChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Returns an array of currently available langs
	     * @returns {any}
	     */
	    TranslateService.prototype.getLangs = function () {
	        return this.langs;
	    };
	    /**
	     * @param langs
	     * Add available langs
	     */
	    TranslateService.prototype.addLangs = function (langs) {
	        var _this = this;
	        langs.forEach(function (lang) {
	            if (_this.langs.indexOf(lang) === -1) {
	                _this.langs.push(lang);
	            }
	        });
	    };
	    /**
	     * Update the list of available langs
	     */
	    TranslateService.prototype.updateLangs = function () {
	        this.addLangs(Object.keys(this.translations));
	    };
	    /**
	     * Returns the parsed result of the translations
	     * @param translations
	     * @param key
	     * @param interpolateParams
	     * @returns {any}
	     */
	    TranslateService.prototype.getParsedResult = function (translations, key, interpolateParams) {
	        var res;
	        if (key instanceof Array) {
	            var result = {}, observables = false;
	            for (var _i = 0, key_1 = key; _i < key_1.length; _i++) {
	                var k = key_1[_i];
	                result[k] = this.getParsedResult(translations, k, interpolateParams);
	                if (typeof result[k].subscribe === "function") {
	                    observables = true;
	                }
	            }
	            if (observables) {
	                var mergedObs = void 0;
	                for (var _a = 0, key_2 = key; _a < key_2.length; _a++) {
	                    var k = key_2[_a];
	                    var obs = typeof result[k].subscribe === "function" ? result[k] : __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(result[k]);
	                    if (typeof mergedObs === "undefined") {
	                        mergedObs = obs;
	                    }
	                    else {
	                        mergedObs = mergedObs.merge(obs);
	                    }
	                }
	                return mergedObs.toArray().map(function (arr) {
	                    var obj = {};
	                    arr.forEach(function (value, index) {
	                        obj[key[index]] = value;
	                    });
	                    return obj;
	                });
	            }
	            return result;
	        }
	        if (translations) {
	            res = this.parser.interpolate(this.parser.getValue(translations, key), interpolateParams);
	        }
	        if (typeof res === "undefined" && this.defaultLang && this.defaultLang !== this.currentLang && this.useDefaultLang) {
	            res = this.parser.interpolate(this.parser.getValue(this.translations[this.defaultLang], key), interpolateParams);
	        }
	        if (typeof res === "undefined") {
	            var params = { key: key, translateService: this };
	            if (typeof interpolateParams !== 'undefined') {
	                params.interpolateParams = interpolateParams;
	            }
	            res = this.missingTranslationHandler.handle(params);
	        }
	        return typeof res !== "undefined" ? res : key;
	    };
	    /**
	     * Gets the translated value of a key (or an array of keys)
	     * @param key
	     * @param interpolateParams
	     * @returns {any} the translated key, or an object of translated keys
	     */
	    TranslateService.prototype.get = function (key, interpolateParams) {
	        var _this = this;
	        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["b" /* isDefined */])(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        // check if we are loading a new translation to use
	        if (this.pending) {
	            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) {
	                var onComplete = function (res) {
	                    observer.next(res);
	                    observer.complete();
	                };
	                var onError = function (err) {
	                    observer.error(err);
	                };
	                _this.loadingTranslations.subscribe(function (res) {
	                    res = _this.getParsedResult(res, key, interpolateParams);
	                    if (typeof res.subscribe === "function") {
	                        res.subscribe(onComplete, onError);
	                    }
	                    else {
	                        onComplete(res);
	                    }
	                }, onError);
	            });
	        }
	        else {
	            var res = this.getParsedResult(this.translations[this.currentLang], key, interpolateParams);
	            if (typeof res.subscribe === "function") {
	                return res;
	            }
	            else {
	                return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(res);
	            }
	        }
	    };
	    /**
	     * Returns a stream of translated values of a key (or an array of keys) which updates
	     * whenever the language changes.
	     * @param key
	     * @param interpolateParams
	     * @returns {any} A stream of the translated key, or an object of translated keys
	     */
	    TranslateService.prototype.stream = function (key, interpolateParams) {
	        var _this = this;
	        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["b" /* isDefined */])(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        return this
	            .get(key, interpolateParams)
	            .concat(this.onLangChange.switchMap(function (event) {
	            var res = _this.getParsedResult(event.translations, key, interpolateParams);
	            if (typeof res.subscribe === "function") {
	                return res;
	            }
	            else {
	                return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(res);
	            }
	        }));
	    };
	    /**
	     * Returns a translation instantly from the internal state of loaded translation.
	     * All rules regarding the current language, the preferred language of even fallback languages will be used except any promise handling.
	     * @param key
	     * @param interpolateParams
	     * @returns {string}
	     */
	    TranslateService.prototype.instant = function (key, interpolateParams) {
	        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["b" /* isDefined */])(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        var res = this.getParsedResult(this.translations[this.currentLang], key, interpolateParams);
	        if (typeof res.subscribe !== "undefined") {
	            if (key instanceof Array) {
	                var obj_1 = {};
	                key.forEach(function (value, index) {
	                    obj_1[key[index]] = key[index];
	                });
	                return obj_1;
	            }
	            return key;
	        }
	        else {
	            return res;
	        }
	    };
	    /**
	     * Sets the translated value of a key, after compiling it
	     * @param key
	     * @param value
	     * @param lang
	     */
	    TranslateService.prototype.set = function (key, value, lang) {
	        if (lang === void 0) { lang = this.currentLang; }
	        this.translations[lang][key] = this.compiler.compile(value, lang);
	        this.updateLangs();
	        this.onTranslationChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Changes the current lang
	     * @param lang
	     */
	    TranslateService.prototype.changeLang = function (lang) {
	        this.currentLang = lang;
	        this.onLangChange.emit({ lang: lang, translations: this.translations[lang] });
	        // if there is no default lang, use the one that we just set
	        if (!this.defaultLang) {
	            this.changeDefaultLang(lang);
	        }
	    };
	    /**
	     * Changes the default lang
	     * @param lang
	     */
	    TranslateService.prototype.changeDefaultLang = function (lang) {
	        this.defaultLang = lang;
	        this.onDefaultLangChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Allows to reload the lang file from the file
	     * @param lang
	     * @returns {Observable<any>}
	     */
	    TranslateService.prototype.reloadLang = function (lang) {
	        this.resetLang(lang);
	        return this.getTranslation(lang);
	    };
	    /**
	     * Deletes inner translation
	     * @param lang
	     */
	    TranslateService.prototype.resetLang = function (lang) {
	        this._translationRequests[lang] = undefined;
	        this.translations[lang] = undefined;
	    };
	    /**
	     * Returns the language code name from the browser, e.g. "de"
	     *
	     * @returns string
	     */
	    TranslateService.prototype.getBrowserLang = function () {
	        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
	            return undefined;
	        }
	        var browserLang = window.navigator.languages ? window.navigator.languages[0] : null;
	        browserLang = browserLang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
	        if (browserLang.indexOf('-') !== -1) {
	            browserLang = browserLang.split('-')[0];
	        }
	        if (browserLang.indexOf('_') !== -1) {
	            browserLang = browserLang.split('_')[0];
	        }
	        return browserLang;
	    };
	    /**
	     * Returns the culture language code name from the browser, e.g. "de-DE"
	     *
	     * @returns string
	     */
	    TranslateService.prototype.getBrowserCultureLang = function () {
	        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
	            return undefined;
	        }
	        var browserCultureLang = window.navigator.languages ? window.navigator.languages[0] : null;
	        browserCultureLang = browserCultureLang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
	        return browserCultureLang;
	    };
	    return TranslateService;
	}());
	TranslateService = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	    __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(USE_DEFAULT_LANG)),
	    __param(6, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(USE_STORE)),
	    __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_10__translate_store__["a" /* TranslateStore */],
	        __WEBPACK_IMPORTED_MODULE_11__translate_loader__["a" /* TranslateLoader */],
	        __WEBPACK_IMPORTED_MODULE_12__translate_compiler__["a" /* TranslateCompiler */],
	        __WEBPACK_IMPORTED_MODULE_14__translate_parser__["a" /* TranslateParser */],
	        __WEBPACK_IMPORTED_MODULE_13__missing_translation_handler__["a" /* MissingTranslationHandler */], Boolean, Boolean])
	], TranslateService);
	
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MissingTranslationHandler; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FakeMissingTranslationHandler; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var MissingTranslationHandler = (function () {
	    function MissingTranslationHandler() {
	    }
	    return MissingTranslationHandler;
	}());
	
	/**
	 * This handler is just a placeholder that does nothing, in case you don't need a missing translation handler at all
	 */
	var FakeMissingTranslationHandler = (function () {
	    function FakeMissingTranslationHandler() {
	    }
	    FakeMissingTranslationHandler.prototype.handle = function (params) {
	        return params.key;
	    };
	    return FakeMissingTranslationHandler;
	}());
	FakeMissingTranslationHandler = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	], FakeMissingTranslationHandler);
	
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateCompiler; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TranslateFakeCompiler; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var TranslateCompiler = (function () {
	    function TranslateCompiler() {
	    }
	    return TranslateCompiler;
	}());
	
	/**
	 * This compiler is just a placeholder that does nothing, in case you don't need a compiler at all
	 */
	var TranslateFakeCompiler = (function (_super) {
	    __extends(TranslateFakeCompiler, _super);
	    function TranslateFakeCompiler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TranslateFakeCompiler.prototype.compile = function (value, lang) {
	        return value;
	    };
	    TranslateFakeCompiler.prototype.compileTranslations = function (translations, lang) {
	        return translations;
	    };
	    return TranslateFakeCompiler;
	}(TranslateCompiler));
	TranslateFakeCompiler = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	], TranslateFakeCompiler);
	
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateLoader; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TranslateFakeLoader; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	var TranslateLoader = (function () {
	    function TranslateLoader() {
	    }
	    return TranslateLoader;
	}());
	
	/**
	 * This loader is just a placeholder that does nothing, in case you don't need a loader at all
	 */
	var TranslateFakeLoader = (function (_super) {
	    __extends(TranslateFakeLoader, _super);
	    function TranslateFakeLoader() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TranslateFakeLoader.prototype.getTranslation = function (lang) {
	        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of({});
	    };
	    return TranslateFakeLoader;
	}(TranslateLoader));
	TranslateFakeLoader = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])()
	], TranslateFakeLoader);
	
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateParser; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TranslateDefaultParser; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(6);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	var TranslateParser = (function () {
	    function TranslateParser() {
	    }
	    return TranslateParser;
	}());
	
	var TranslateDefaultParser = (function (_super) {
	    __extends(TranslateDefaultParser, _super);
	    function TranslateDefaultParser() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
	        return _this;
	    }
	    TranslateDefaultParser.prototype.interpolate = function (expr, params) {
	        var result;
	        if (typeof expr === 'string') {
	            result = this.interpolateString(expr, params);
	        }
	        else if (typeof expr === 'function') {
	            result = this.interpolateFunction(expr, params);
	        }
	        else {
	            // this should not happen, but an unrelated TranslateService test depends on it
	            result = expr;
	        }
	        return result;
	    };
	    TranslateDefaultParser.prototype.getValue = function (target, key) {
	        var keys = key.split('.');
	        key = '';
	        do {
	            key += keys.shift();
	            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(target) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(target[key]) && (typeof target[key] === 'object' || !keys.length)) {
	                target = target[key];
	                key = '';
	            }
	            else if (!keys.length) {
	                target = undefined;
	            }
	            else {
	                key += '.';
	            }
	        } while (keys.length);
	        return target;
	    };
	    TranslateDefaultParser.prototype.interpolateFunction = function (fn, params) {
	        return fn(params);
	    };
	    TranslateDefaultParser.prototype.interpolateString = function (expr, params) {
	        var _this = this;
	        if (!params) {
	            return expr;
	        }
	        return expr.replace(this.templateMatcher, function (substring, b) {
	            var r = _this.getValue(params, b);
	            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(r) ? r : substring;
	        });
	    };
	    return TranslateDefaultParser;
	}(TranslateParser));
	TranslateDefaultParser = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	], TranslateDefaultParser);
	
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = equals;
	/* harmony export (immutable) */ __webpack_exports__["b"] = isDefined;
	/* unused harmony export isObject */
	/* harmony export (immutable) */ __webpack_exports__["c"] = mergeDeep;
	/* tslint:disable */
	/**
	 * @name equals
	 *
	 * @description
	 * Determines if two objects or two values are equivalent.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `equals`.
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 */
	/* tslint:disable */ function equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	    if (t1 == t2 && t1 == 'object') {
	        if (Array.isArray(o1)) {
	            if (!Array.isArray(o2))
	                return false;
	            if ((length = o1.length) == o2.length) {
	                for (key = 0; key < length; key++) {
	                    if (!equals(o1[key], o2[key]))
	                        return false;
	                }
	                return true;
	            }
	        }
	        else {
	            if (Array.isArray(o2)) {
	                return false;
	            }
	            keySet = Object.create(null);
	            for (key in o1) {
	                if (!equals(o1[key], o2[key])) {
	                    return false;
	                }
	                keySet[key] = true;
	            }
	            for (key in o2) {
	                if (!(key in keySet) && typeof o2[key] !== 'undefined') {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	    return false;
	}
	/* tslint:enable */
	function isDefined(value) {
	    return typeof value !== 'undefined' && value !== null;
	}
	function isObject(item) {
	    return (item && typeof item === 'object' && !Array.isArray(item));
	}
	function mergeDeep(target, source) {
	    target = JSON.parse(JSON.stringify(target));
	    source = JSON.parse(JSON.stringify(source));
	    var output = Object.assign({}, target);
	    if (isObject(target) && isObject(source)) {
	        Object.keys(source).forEach(function (key) {
	            if (isObject(source[key])) {
	                if (!(key in target)) {
	                    Object.assign(output, (_a = {}, _a[key] = source[key], _a));
	                }
	                else {
	                    output[key] = mergeDeep(target[key], source[key]);
	                }
	            }
	            else {
	                Object.assign(output, (_b = {}, _b[key] = source[key], _b));
	            }
	            var _a, _b;
	        });
	    }
	    return output;
	}
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translate_service__ = __webpack_require__(1);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var TranslateDirective = (function () {
	    function TranslateDirective(translateService, element, _ref) {
	        var _this = this;
	        this.translateService = translateService;
	        this.element = element;
	        this._ref = _ref;
	        // subscribe to onTranslationChange event, in case the translations of the current lang change
	        if (!this.onTranslationChangeSub) {
	            this.onTranslationChangeSub = this.translateService.onTranslationChange.subscribe(function (event) {
	                if (event.lang === _this.translateService.currentLang) {
	                    _this.checkNodes(true, event.translations);
	                }
	            });
	        }
	        // subscribe to onLangChange event, in case the language changes
	        if (!this.onLangChangeSub) {
	            this.onLangChangeSub = this.translateService.onLangChange.subscribe(function (event) {
	                _this.checkNodes(true, event.translations);
	            });
	        }
	        // subscribe to onDefaultLangChange event, in case the default language changes
	        if (!this.onDefaultLangChangeSub) {
	            this.onDefaultLangChangeSub = this.translateService.onDefaultLangChange.subscribe(function (event) {
	                _this.checkNodes(true);
	            });
	        }
	    }
	    Object.defineProperty(TranslateDirective.prototype, "translate", {
	        set: function (key) {
	            if (key) {
	                this.key = key;
	                this.checkNodes();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateDirective.prototype, "translateParams", {
	        set: function (params) {
	            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* equals */])(this.currentParams, params)) {
	                this.currentParams = params;
	                this.checkNodes(true);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TranslateDirective.prototype.ngAfterViewChecked = function () {
	        this.checkNodes();
	    };
	    TranslateDirective.prototype.checkNodes = function (forceUpdate, translations) {
	        if (forceUpdate === void 0) { forceUpdate = false; }
	        var nodes = this.element.nativeElement.childNodes;
	        // if the element is empty
	        if (!nodes.length) {
	            // we add the key as content
	            this.setContent(this.element.nativeElement, this.key);
	            nodes = this.element.nativeElement.childNodes;
	        }
	        for (var i = 0; i < nodes.length; ++i) {
	            var node = nodes[i];
	            if (node.nodeType === 3) {
	                var key = void 0;
	                if (this.key) {
	                    key = this.key;
	                    if (forceUpdate) {
	                        node.lastKey = null;
	                    }
	                }
	                else {
	                    var content = this.getContent(node).trim();
	                    if (content.length) {
	                        // we want to use the content as a key, not the translation value
	                        if (content !== node.currentValue) {
	                            key = content;
	                            // the content was changed from the user, we'll use it as a reference if needed
	                            node.originalContent = this.getContent(node);
	                        }
	                        else if (node.originalContent && forceUpdate) {
	                            node.lastKey = null;
	                            // the current content is the translation, not the key, use the last real content as key
	                            key = node.originalContent.trim();
	                        }
	                    }
	                }
	                this.updateValue(key, node, translations);
	            }
	        }
	    };
	    TranslateDirective.prototype.updateValue = function (key, node, translations) {
	        var _this = this;
	        if (key) {
	            if (node.lastKey === key && this.lastParams === this.currentParams) {
	                return;
	            }
	            this.lastParams = this.currentParams;
	            var onTranslation = function (res) {
	                if (res !== key) {
	                    node.lastKey = key;
	                }
	                if (!node.originalContent) {
	                    node.originalContent = _this.getContent(node);
	                }
	                node.currentValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(res) ? res : (node.originalContent || key);
	                // we replace in the original content to preserve spaces that we might have trimmed
	                _this.setContent(node, _this.key ? node.currentValue : node.originalContent.replace(key, node.currentValue));
	                _this._ref.markForCheck();
	            };
	            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(translations)) {
	                var res = this.translateService.getParsedResult(translations, key, this.currentParams);
	                if (typeof res.subscribe === "function") {
	                    res.subscribe(onTranslation);
	                }
	                else {
	                    onTranslation(res);
	                }
	            }
	            else {
	                this.translateService.get(key, this.currentParams).subscribe(onTranslation);
	            }
	        }
	    };
	    TranslateDirective.prototype.getContent = function (node) {
	        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(node.textContent) ? node.textContent : node.data;
	    };
	    TranslateDirective.prototype.setContent = function (node, content) {
	        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(node.textContent)) {
	            node.textContent = content;
	        }
	        else {
	            node.data = content;
	        }
	    };
	    TranslateDirective.prototype.ngOnDestroy = function () {
	        if (this.onLangChangeSub) {
	            this.onLangChangeSub.unsubscribe();
	        }
	        if (this.onDefaultLangChangeSub) {
	            this.onDefaultLangChangeSub.unsubscribe();
	        }
	        if (this.onTranslationChangeSub) {
	            this.onTranslationChangeSub.unsubscribe();
	        }
	    };
	    return TranslateDirective;
	}());
	__decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	    __metadata("design:type", String),
	    __metadata("design:paramtypes", [String])
	], TranslateDirective.prototype, "translate", null);
	__decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	    __metadata("design:type", Object),
	    __metadata("design:paramtypes", [Object])
	], TranslateDirective.prototype, "translateParams", null);
	TranslateDirective = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	        selector: '[translate],[ngx-translate]'
	    }),
	    __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__translate_service__["c" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]])
	], TranslateDirective);
	
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslatePipe; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translate_service__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(6);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var TranslatePipe = (function () {
	    function TranslatePipe(translate, _ref) {
	        this.translate = translate;
	        this._ref = _ref;
	        this.value = '';
	    }
	    TranslatePipe.prototype.updateValue = function (key, interpolateParams, translations) {
	        var _this = this;
	        var onTranslation = function (res) {
	            _this.value = res !== undefined ? res : key;
	            _this.lastKey = key;
	            _this._ref.markForCheck();
	        };
	        if (translations) {
	            var res = this.translate.getParsedResult(translations, key, interpolateParams);
	            if (typeof res.subscribe === 'function') {
	                res.subscribe(onTranslation);
	            }
	            else {
	                onTranslation(res);
	            }
	        }
	        this.translate.get(key, interpolateParams).subscribe(onTranslation);
	    };
	    TranslatePipe.prototype.transform = function (query) {
	        var _this = this;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (!query || query.length === 0) {
	            return query;
	        }
	        // if we ask another time for the same key, return the last value
	        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* equals */])(query, this.lastKey) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* equals */])(args, this.lastParams)) {
	            return this.value;
	        }
	        var interpolateParams;
	        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* isDefined */])(args[0]) && args.length) {
	            if (typeof args[0] === 'string' && args[0].length) {
	                // we accept objects written in the template such as {n:1}, {'n':1}, {n:'v'}
	                // which is why we might need to change it to real JSON objects such as {"n":1} or {"n":"v"}
	                var validArgs = args[0]
	                    .replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":')
	                    .replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
	                try {
	                    interpolateParams = JSON.parse(validArgs);
	                }
	                catch (e) {
	                    throw new SyntaxError("Wrong parameter in TranslatePipe. Expected a valid Object, received: " + args[0]);
	                }
	            }
	            else if (typeof args[0] === 'object' && !Array.isArray(args[0])) {
	                interpolateParams = args[0];
	            }
	        }
	        // store the query, in case it changes
	        this.lastKey = query;
	        // store the params, in case they change
	        this.lastParams = args;
	        // set the value
	        this.updateValue(query, interpolateParams);
	        // if there is a subscription to onLangChange, clean it
	        this._dispose();
	        // subscribe to onTranslationChange event, in case the translations change
	        if (!this.onTranslationChange) {
	            this.onTranslationChange = this.translate.onTranslationChange.subscribe(function (event) {
	                if (_this.lastKey && event.lang === _this.translate.currentLang) {
	                    _this.lastKey = null;
	                    _this.updateValue(query, interpolateParams, event.translations);
	                }
	            });
	        }
	        // subscribe to onLangChange event, in case the language changes
	        if (!this.onLangChange) {
	            this.onLangChange = this.translate.onLangChange.subscribe(function (event) {
	                if (_this.lastKey) {
	                    _this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
	                    _this.updateValue(query, interpolateParams, event.translations);
	                }
	            });
	        }
	        // subscribe to onDefaultLangChange event, in case the default language changes
	        if (!this.onDefaultLangChange) {
	            this.onDefaultLangChange = this.translate.onDefaultLangChange.subscribe(function () {
	                if (_this.lastKey) {
	                    _this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
	                    _this.updateValue(query, interpolateParams);
	                }
	            });
	        }
	        return this.value;
	    };
	    /**
	     * Clean any existing subscription to change events
	     * @private
	     */
	    TranslatePipe.prototype._dispose = function () {
	        if (typeof this.onTranslationChange !== 'undefined') {
	            this.onTranslationChange.unsubscribe();
	            this.onTranslationChange = undefined;
	        }
	        if (typeof this.onLangChange !== 'undefined') {
	            this.onLangChange.unsubscribe();
	            this.onLangChange = undefined;
	        }
	        if (typeof this.onDefaultLangChange !== 'undefined') {
	            this.onDefaultLangChange.unsubscribe();
	            this.onDefaultLangChange = undefined;
	        }
	    };
	    TranslatePipe.prototype.ngOnDestroy = function () {
	        this._dispose();
	    };
	    return TranslatePipe;
	}());
	TranslatePipe = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
	        name: 'translate',
	        pure: false // required to update the value when the promise is resolved
	    }),
	    __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__translate_service__["c" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]])
	], TranslatePipe);
	
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateStore; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	
	var TranslateStore = (function () {
	    function TranslateStore() {
	        /**
	         * The lang currently used
	         * @type {string}
	         */
	        this.currentLang = this.defaultLang;
	        /**
	         * a list of translations per lang
	         * @type {{}}
	         */
	        this.translations = {};
	        /**
	         * an array of langs
	         * @type {Array}
	         */
	        this.langs = [];
	        /**
	         * An EventEmitter to listen to translation change events
	         * onTranslationChange.subscribe((params: TranslationChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<TranslationChangeEvent>}
	         */
	        this.onTranslationChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /**
	         * An EventEmitter to listen to lang change events
	         * onLangChange.subscribe((params: LangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<LangChangeEvent>}
	         */
	        this.onLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /**
	         * An EventEmitter to listen to default lang change events
	         * onDefaultLangChange.subscribe((params: DefaultLangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<DefaultLangChangeEvent>}
	         */
	        this.onDefaultLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	    }
	    return TranslateStore;
	}());
	
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_10__;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TranslateModule", function() { return TranslateModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_translate_service__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_translate_directive__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_translate_pipe__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_translate_store__ = __webpack_require__(9);
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateLoader", function() { return __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateFakeLoader", function() { return __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "USE_STORE", function() { return __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "USE_DEFAULT_LANG", function() { return __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateService", function() { return __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["c"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MissingTranslationHandler", function() { return __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FakeMissingTranslationHandler", function() { return __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateParser", function() { return __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateDefaultParser", function() { return __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateCompiler", function() { return __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateFakeCompiler", function() { return __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateDirective", function() { return __WEBPACK_IMPORTED_MODULE_6__src_translate_directive__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslatePipe", function() { return __WEBPACK_IMPORTED_MODULE_7__src_translate_pipe__["a"]; });
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var TranslateModule = TranslateModule_1 = (function () {
	    function TranslateModule() {
	    }
	    /**
	     * Use this method in your root module to provide the TranslateService
	     * @param {TranslateModuleConfig} config
	     * @returns {ModuleWithProviders}
	     */
	    TranslateModule.forRoot = function (config) {
	        if (config === void 0) { config = {}; }
	        return {
	            ngModule: TranslateModule_1,
	            providers: [
	                config.loader || { provide: __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["a" /* TranslateLoader */], useClass: __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["b" /* TranslateFakeLoader */] },
	                config.compiler || { provide: __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["a" /* TranslateCompiler */], useClass: __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["b" /* TranslateFakeCompiler */] },
	                config.parser || { provide: __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["a" /* TranslateParser */], useClass: __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["b" /* TranslateDefaultParser */] },
	                config.missingTranslationHandler || { provide: __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["a" /* MissingTranslationHandler */], useClass: __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["b" /* FakeMissingTranslationHandler */] },
	                __WEBPACK_IMPORTED_MODULE_8__src_translate_store__["a" /* TranslateStore */],
	                { provide: __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["a" /* USE_STORE */], useValue: config.isolate },
	                { provide: __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["b" /* USE_DEFAULT_LANG */], useValue: config.useDefaultLang },
	                __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["c" /* TranslateService */]
	            ]
	        };
	    };
	    /**
	     * Use this method in your other (non root) modules to import the directive/pipe
	     * @param {TranslateModuleConfig} config
	     * @returns {ModuleWithProviders}
	     */
	    TranslateModule.forChild = function (config) {
	        if (config === void 0) { config = {}; }
	        return {
	            ngModule: TranslateModule_1,
	            providers: [
	                config.loader || { provide: __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["a" /* TranslateLoader */], useClass: __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["b" /* TranslateFakeLoader */] },
	                config.compiler || { provide: __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["a" /* TranslateCompiler */], useClass: __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["b" /* TranslateFakeCompiler */] },
	                config.parser || { provide: __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["a" /* TranslateParser */], useClass: __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["b" /* TranslateDefaultParser */] },
	                config.missingTranslationHandler || { provide: __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["a" /* MissingTranslationHandler */], useClass: __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["b" /* FakeMissingTranslationHandler */] },
	                { provide: __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["a" /* USE_STORE */], useValue: config.isolate },
	                { provide: __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["b" /* USE_DEFAULT_LANG */], useValue: config.useDefaultLang },
	                __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["c" /* TranslateService */]
	            ]
	        };
	    };
	    return TranslateModule;
	}());
	TranslateModule = TranslateModule_1 = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
	        declarations: [
	            __WEBPACK_IMPORTED_MODULE_7__src_translate_pipe__["a" /* TranslatePipe */],
	            __WEBPACK_IMPORTED_MODULE_6__src_translate_directive__["a" /* TranslateDirective */]
	        ],
	        exports: [
	            __WEBPACK_IMPORTED_MODULE_7__src_translate_pipe__["a" /* TranslatePipe */],
	            __WEBPACK_IMPORTED_MODULE_6__src_translate_directive__["a" /* TranslateDirective */]
	        ]
	    })
	], TranslateModule);
	
	var TranslateModule_1;
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_13__;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_14__;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_15__;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_16__;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_17__;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_18__;
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_19__;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(69));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Shared Modules
	var common_1 = __webpack_require__(22);
	var router_1 = __webpack_require__(70);
	// Shared Services
	var services_1 = __webpack_require__(88);
	// Components
	var FooterComponent_1 = __webpack_require__(103);
	var MainMenuComponent_1 = __webpack_require__(109);
	var TopMenuComponent_1 = __webpack_require__(118);
	var MenuHoverDirective_1 = __webpack_require__(121);
	var AdminHeaderComponent_1 = __webpack_require__(122);
	var AdminHeaderAuthComponent_1 = __webpack_require__(128);
	var AdminSidebarComponent_1 = __webpack_require__(131);
	// Services
	var AdminService_1 = __webpack_require__(113);
	var services_2 = __webpack_require__(134);
	var HolidayService_1 = __webpack_require__(112);
	// import { HolidayService } from '../../../holiday/services/HolidayService';
	var core_2 = __webpack_require__(38);
	var ClickOutsideDirective_1 = __webpack_require__(135);
	var primeng_1 = __webpack_require__(149);
	var forms_1 = __webpack_require__(26);
	var CoreModule = (function () {
	    function CoreModule(parentModule) {
	        // Guard to make sure that the CoreModule will be loaded one time only in the AppModule
	        if (parentModule) {
	            throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
	        }
	    }
	    return CoreModule;
	}());
	CoreModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            common_1.CommonModule,
	            router_1.RouterModule,
	            forms_1.FormsModule,
	            core_2.TranslateModule,
	            primeng_1.DialogModule,
	            primeng_1.GrowlModule
	        ],
	        declarations: [
	            FooterComponent_1.FooterComponent,
	            MainMenuComponent_1.MainMenuComponent,
	            TopMenuComponent_1.TopMenuComponent,
	            MenuHoverDirective_1.MenuHoverDirective,
	            ClickOutsideDirective_1.ClickOutsideDirective,
	            AdminHeaderComponent_1.AdminHeaderComponent,
	            AdminHeaderAuthComponent_1.AdminHeaderAuthComponent,
	            AdminSidebarComponent_1.AdminSidebarComponent
	        ],
	        providers: [
	            // Services
	            services_1.SettingService,
	            services_1.ApiService,
	            services_1.LocalStorageService,
	            services_1.SessionStorageService,
	            services_1.FileService,
	            services_1.CatalogService,
	            services_1.StudentService,
	            services_1.MenuService,
	            AdminService_1.AdminService,
	            services_1.LocalNetworkService,
	            services_2.SessionService,
	            HolidayService_1.HolidayService
	        ],
	        exports: [
	            FooterComponent_1.FooterComponent,
	            MainMenuComponent_1.MainMenuComponent,
	            TopMenuComponent_1.TopMenuComponent,
	            MenuHoverDirective_1.MenuHoverDirective,
	            AdminHeaderComponent_1.AdminHeaderComponent,
	            AdminHeaderAuthComponent_1.AdminHeaderAuthComponent,
	            AdminSidebarComponent_1.AdminSidebarComponent
	        ]
	    })
	    /**
	     * The CoreModule which will define the modules, components & directives that will
	     * be called only onetime in the main AppModule when the app loads. Do not import
	     * the CoreModule more than one time.
	     */
	    ,
	    __param(0, core_1.Optional()), __param(0, core_1.SkipSelf()),
	    __metadata("design:paramtypes", [CoreModule])
	], CoreModule);
	exports.CoreModule = CoreModule;


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(89));
	__export(__webpack_require__(90));
	__export(__webpack_require__(96));
	__export(__webpack_require__(97));
	__export(__webpack_require__(91));
	__export(__webpack_require__(98));
	__export(__webpack_require__(95));
	__export(__webpack_require__(99));
	__export(__webpack_require__(102));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	var http_1 = __webpack_require__(30);
	var ApiService = (function () {
	    function ApiService(http) {
	        this.http = http;
	    }
	    /**
	     * Get Method to get data from Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.get = function (requestUrl) {
	        var options = new http_1.RequestOptions({ withCredentials: true });
	        return this.http.get(requestUrl, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Get Method to get data from Api Endpoint - Use to export pdf
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.getFile = function (requestUrl) {
	        var options = new http_1.RequestOptions({
	            withCredentials: true,
	        });
	        return this.http.get(requestUrl, options)
	            .map(function (response) {
	            var body = JSON.parse(response['_body']);
	            return body.buffer.data;
	        })
	            .catch(this.handleError);
	    };
	    /**
	 * Get Method to get data from Api Endpoint
	 * @param requestUrl - string
	 * @return Observable<Type>
	 */
	    ApiService.prototype.getToThirdParty = function (requestUrl) {
	        return this.http.get(requestUrl)
	            .map(function (res) { return res.json(); })
	            .catch(this.handleError);
	    };
	    /**
	     * Post Method to post data from Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.post = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.post(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Put Method to post data to Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.put = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.put(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Patch Method to update data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.patch = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            method: http_1.RequestMethod.Patch,
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.patch(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Delete Method to remove the data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.delete = function (requestUrl) {
	        var options = new http_1.RequestOptions({ withCredentials: true });
	        return this.http.delete(requestUrl, options)
	            .catch(this.handleError);
	    };
	    /**
	     * Delete Method to remove the data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.deletePost = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            method: http_1.RequestMethod.Delete,
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.post(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Extract Response data from Request Response
	     * @param res: Response
	     * @return JSON data
	     */
	    ApiService.prototype.extractData = function (res) {
	        var body;
	        var contentType = res.headers.get("content-type");
	        // If response has content type "application/json"
	        // then parse the body
	        if (contentType && contentType.indexOf('application/json') !== -1) {
	            try {
	                body = res.json();
	            }
	            catch (error) {
	                body = {};
	            }
	        }
	        else {
	            body = res.text();
	        }
	        return body;
	    };
	    /**
	     * Handle Error returned from Request Response
	     * @param error: any
	     * @return Observable<error>
	     */
	    ApiService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        // console.log(errMsg); // log to console instead
	        return Observable_1.Observable.throw(error);
	    };
	    return ApiService;
	}());
	ApiService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [http_1.Http])
	], ApiService);
	exports.ApiService = ApiService;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	// Services
	var ApiService_1 = __webpack_require__(89);
	var SettingService_1 = __webpack_require__(91);
	var FileService_1 = __webpack_require__(95);
	var CatalogService = (function () {
	    function CatalogService(apiService, settingService, fileService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.fileService = fileService;
	        this.fullCampusUrl = '/included-campuses';
	        this.campusUrl = '/campuses';
	        this.homeroomUrl = '/homerooms';
	        this.schoolyearUrl = '/school-years';
	        this.yearGroupUrl = '/yearGroups';
	        this.yearLevelUrl = '/year-levels';
	        this.semesterUrl = '/semesters';
	        this.gradeClassUrl = '/gradeClasses';
	        this.termUrl = '/terms';
	        this.periodUrl = '/asa-periods';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get campus items
	     * @returns {Observable<Campus[]>} Array list of Campus class
	     */
	    CatalogService.prototype.getCampuses = function () {
	        var requestUrl = this.apiUrl + this.campusUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get full campus item with contain yearlevels and homerooms.
	     * @returns {Observable<CampusFullItem[]>} Array list of CampusFullItem class
	     */
	    CatalogService.prototype.getCampusesFullItems = function () {
	        var requestUrl = this.apiUrl + this.fullCampusUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get homerooms
	     * @returns {Observable<gradeClass[]>} Array list of gradeClass class
	     */
	    CatalogService.prototype.getHomerooms = function () {
	        var requestUrl = this.apiUrl + this.homeroomUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get school years
	     * @returns {Observable<Schoolyear[]>} Array list of Schoolyear class
	     */
	    CatalogService.prototype.getSchoolyears = function () {
	        var requestUrl = this.apiUrl + this.schoolyearUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get year levels
	     * @returns {Observable<YearGroup[]>} Array list of YearGroup class
	     */
	    CatalogService.prototype.getYearLevels = function () {
	        var requestUrl = this.apiUrl + this.yearLevelUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getSemesters = function () {
	        var requestUrl = this.apiUrl + this.semesterUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Handle Promise errors
	     * @returns {String} Message error
	     */
	    CatalogService.prototype.handleError = function (error) {
	        return Promise.reject(error.message || error);
	    };
	    /**
	     * Get Year Groups
	     * @returns {Observable<YearGroup[]>} Array list of YearGroup class
	     */
	    CatalogService.prototype.getYearGroups = function () {
	        var requestUrl = this.apiUrl + this.yearGroupUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getTerms = function () {
	        var requestUrl = this.apiUrl + this.termUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get grade_classes
	     * @returns {Observable<gradeClass[]>} Array list of gradeClass class
	     */
	    CatalogService.prototype.getGradeClasses = function () {
	        var requestUrl = this.apiUrl + this.gradeClassUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getPeriodByTermId = function (termId) {
	        var requestUrl = this.apiUrl + this.periodUrl + '?term_id=' + termId;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.gePeriodByCurrentTerm = function () {
	        var _this = this;
	        return this.getTerms()
	            .map(function (termList) { return _.filter(termList, function (o) { return o.is_current; })[0].id; })
	            .switchMap(function (currentTermId) { return currentTermId ? _this.getPeriodByTermId(currentTermId) : Observable_1.Observable.of(null); });
	    };
	    CatalogService.prototype.getPeriods = function () {
	        var requestUrl = this.apiUrl + this.periodUrl;
	        return this.apiService.get(requestUrl);
	    };
	    return CatalogService;
	}());
	CatalogService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService,
	        FileService_1.FileService])
	], CatalogService);
	exports.CatalogService = CatalogService;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Setting configuration
	var Setting_1 = __webpack_require__(92);
	// Lodash
	var _ = __webpack_require__(93);
	var SettingService = (function () {
	    function SettingService() {
	    }
	    /**
	     * Find in the setting list the setting that has
	     * the id matched with settingId input
	     * @param {string} settingId - the id of the setting
	     * @return {string} - the setting value or empty string
	     */
	    SettingService.prototype.getSetting = function (settingId) {
	        var result = _.find(Setting_1.SETTINGS, { 'id': settingId });
	        return result ? result.value : '';
	    };
	    return SettingService;
	}());
	SettingService = __decorate([
	    core_1.Injectable()
	], SettingService);
	exports.SettingService = SettingService;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Setting = (function () {
	    function Setting() {
	    }
	    return Setting;
	}());
	exports.Setting = Setting;
	exports.SETTINGS = [
	    {
	        id: 'api_service_domain',
	        value: '/api'
	    }
	];


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	// Import Setting Service and User, Credential Model
	var SettingService_1 = __webpack_require__(91);
	var ApiService_1 = __webpack_require__(89);
	var FileService = (function () {
	    function FileService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.fileUrl = '/files';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    FileService.prototype.uploadFile = function (data) {
	        var requestUrl = this.apiUrl + this.fileUrl;
	        return this.apiService.post(requestUrl, data);
	    };
	    FileService.prototype.getFile = function (fileId) {
	        return this.apiUrl + this.fileUrl + '/' + fileId;
	    };
	    return FileService;
	}());
	FileService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [SettingService_1.SettingService,
	        ApiService_1.ApiService])
	], FileService);
	exports.FileService = FileService;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var LocalStorageService = (function () {
	    function LocalStorageService() {
	    }
	    LocalStorageService.prototype.getData = function (key) {
	        var text = window.localStorage.getItem(key);
	        return JSON.parse(text);
	    };
	    LocalStorageService.prototype.setData = function (key, data) {
	        var text = JSON.stringify(data);
	        try {
	            window.localStorage.setItem(key, text);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot set local storage data:");
	            console.log(data);
	            return false;
	        }
	    };
	    LocalStorageService.prototype.removeData = function (key) {
	        try {
	            window.localStorage.removeItem(key);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot remove local storage data. Data key: " + key);
	            return false;
	        }
	    };
	    return LocalStorageService;
	}());
	LocalStorageService = __decorate([
	    core_1.Injectable()
	], LocalStorageService);
	exports.LocalStorageService = LocalStorageService;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var SessionStorageService = (function () {
	    function SessionStorageService() {
	    }
	    SessionStorageService.prototype.getData = function (key) {
	        var text = window.sessionStorage.getItem(key);
	        return text ? JSON.parse(text) : '';
	    };
	    SessionStorageService.prototype.setData = function (key, data) {
	        var text = JSON.stringify(data);
	        try {
	            window.sessionStorage.setItem(key, text);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot set local storage data:");
	            console.log(data);
	            return false;
	        }
	    };
	    SessionStorageService.prototype.removeData = function (key) {
	        try {
	            window.sessionStorage.removeItem(key);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot remove local storage data. Data key: " + key);
	            return false;
	        }
	    };
	    return SessionStorageService;
	}());
	SessionStorageService = __decorate([
	    core_1.Injectable()
	], SessionStorageService);
	exports.SessionStorageService = SessionStorageService;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var ApiService_1 = __webpack_require__(89);
	var SettingService_1 = __webpack_require__(91);
	var StudentService = (function () {
	    function StudentService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.studentUrl = '/bus-students';
	        this.holidayStudentUrl = '/hol/student';
	        this.studentScheduleUrl = '/asa-required-class-children';
	        this.importStudentScheduleUrl = '/students-schedule';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     *
	     */
	    StudentService.prototype.getStudents = function (filter) {
	        var requestUrl = this.apiUrl + this.studentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudents = function (holidayStudentFilter) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in holidayStudentFilter) {
	            if (holidayStudentFilter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + holidayStudentFilter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudentDetail = function (studentId) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl + '?id=' + studentId + '&page=1';
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.updateHolidayStudentStatus = function (data) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        // Post content
	        var body = JSON.stringify(data);
	        return this.apiService.patch(requestUrl, body);
	    };
	    StudentService.prototype.getStudentsSchedule = function (filter) {
	        var requestUrl = this.apiUrl + this.studentScheduleUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudentInfo = function () {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.importStudent = function (data) {
	        var requestUrl = this.apiUrl + this.studentUrl;
	        return this.apiService.patch(requestUrl, data);
	    };
	    StudentService.prototype.importStudentSchedule = function (data) {
	        var requestUrl = this.apiUrl + this.importStudentScheduleUrl;
	        return this.apiService.patch(requestUrl, data);
	    };
	    StudentService.prototype.updateStudentStatus = function (studentId, data) {
	        var requestUrl = this.apiUrl + this.studentUrl + "/" + studentId;
	        // Post content
	        var body = JSON.stringify(data);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // Edit student
	    StudentService.prototype.editHolidayStudent = function (studentDetail) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        var body = JSON.stringify(studentDetail);
	        return this.apiService.patch(requestUrl, body);
	    };
	    //generate list period with day
	    StudentService.prototype.showClassByPeriodAndDay = function (period, weekdays) {
	        var iWeekdaysLength = weekdays.length;
	        var periodCompareName;
	        for (var i = 0; i < iWeekdaysLength; i++) {
	            periodCompareName = weekdays[i].period_name + " " + weekdays[i].day;
	            if (_.parseInt(weekdays[i].period_id) === period.id && periodCompareName.toLowerCase() === period.displayName.toLowerCase()) {
	                return weekdays[i].class || weekdays[i].class_info.name;
	            }
	        }
	        return '';
	    };
	    return StudentService;
	}());
	StudentService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService])
	], StudentService);
	exports.StudentService = StudentService;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Menu for application
	var Menu_1 = __webpack_require__(100);
	var CampusInfo_1 = __webpack_require__(101);
	// Lodash
	var _ = __webpack_require__(93);
	var MenuService = (function () {
	    function MenuService() {
	    }
	    /**
	     * Find in the menu type list the menu list that has
	     * the name matched with menuType input
	     * @param {string} menuType - the name of the menu list
	     * @return { Menu[] | [] } - list of menu or empty list
	     */
	    MenuService.prototype.getMenuList = function (menuType) {
	        var result = _.find(Menu_1.MENUS, { 'name': menuType });
	        return result ? result.menuList : [];
	    };
	    MenuService.prototype.getCampusInfo = function () {
	        return CampusInfo_1.CAMPUS_INFOS;
	    };
	    return MenuService;
	}());
	MenuService = __decorate([
	    core_1.Injectable()
	], MenuService);
	exports.MenuService = MenuService;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Menu = (function () {
	    function Menu() {
	    }
	    return Menu;
	}());
	exports.Menu = Menu;
	var MenuType = (function () {
	    function MenuType() {
	    }
	    return MenuType;
	}());
	exports.MenuType = MenuType;
	var MenuStatus = (function () {
	    function MenuStatus() {
	    }
	    return MenuStatus;
	}());
	exports.MenuStatus = MenuStatus;
	exports.MENUS = [
	    // Top menu list
	    {
	        name: "top",
	        menuList: [
	            {
	                "id": "news-event",
	                "label": "News & Events",
	                "url": "http://www.aisvietnam.com/category/news-events/",
	                "type": "link",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "photo-gallery",
	                "label": "Photo Gallery",
	                "url": "http://www.aisvietnam.com/photo-gallery/",
	                "type": "link",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "login-mail",
	                "label": "Login Mail",
	                "url": "https://portal.office.com",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "my-ais",
	                "label": "myAIS",
	                "url": "http://www.myais.vn",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "sitemap",
	                "label": "Sitemap",
	                "url": "http://www.aisvietnam.com/sitemap",
	                "type": "link",
	                "target": "",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // Social connect top menu list
	    {
	        name: 'social-top',
	        menuList: [
	            {
	                "id": "facebook",
	                "label": "Facebook",
	                "url": "https://www.facebook.com/AustralianInternationalSchoolVietnam/",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "twitter",
	                "label": "Twitter",
	                "url": "https://twitter.com/#!/aisvietnam",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "google",
	                "label": "Google",
	                "url": "https://plus.google.com/u/0/+AustralianInternationalSchoolVietnamTT/posts",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "youtube",
	                "label": "Youtube",
	                "url": "https://www.youtube.com/user/aisvietnam",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "envelope-o",
	                "label": "Email",
	                "url": "http://portal.office.com/",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // Login main menu
	    {
	        name: "login-main",
	        menuList: [
	            {
	                "id": "register",
	                "label": "Register",
	                "url": "/hol-register",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "login",
	                "label": "Login",
	                "url": "/hol-login",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // Login main menu
	    {
	        name: "hol-login",
	        menuList: [
	            {
	                "id": "register",
	                "label": "Register",
	                "url": "/hol-register",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "login",
	                "label": "Login",
	                "url": "/hol-login",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // Camp module main menu list
	    {
	        name: 'camp-main',
	        menuList: []
	    },
	    // ASA module main menu list
	    {
	        name: "asa-main",
	        menuList: []
	    },
	    // ASA module sub menu list
	    {
	        name: "asa-sub",
	        menuList: [
	            {
	                "id": "bookingClasses",
	                "label": "Booking Classes",
	                "url": "/booking/students",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            // {
	            //     "id": "manageBooking",
	            //     "label": "Manage Booking",
	            //     "url":	"",
	            //     "type":	"route",
	            //     "target": "",
	            //     "icon": "",
	            //     "role": []
	            // },
	            {
	                "id": "attendance",
	                "label": "Attendance",
	                "url": "/parent/attendance",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "schedule",
	                "label": "Schedule",
	                "url": "/schedule/list",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // Camp module admin sidebar list
	    {
	        name: 'camp-admin-sidebar',
	        menuList: [
	            {
	                "id": "camp-program",
	                "label": "Camp Programmes",
	                "url": "/camps/list",
	                "type": "route",
	                "target": "",
	                "icon": "nature_people",
	                "role": []
	            },
	            {
	                "id": "student",
	                "label": "Students",
	                "url": "/students/list",
	                "type": "route",
	                "target": "",
	                "icon": "people",
	                "role": []
	            },
	            {
	                "id": "camp-report",
	                "label": "Camp Reports",
	                "url": "/camps/report",
	                "type": "route",
	                "target": "",
	                "icon": "rate_review",
	                "role": []
	            }
	        ]
	    },
	    // Asa module admin sidebar list
	    {
	        name: 'asa-admin-sidebar',
	        menuList: [
	            {
	                "id": "classes",
	                "label": "Classes",
	                "url": "/classes/list",
	                "type": "route",
	                "target": "",
	                "icon": "store",
	                "role": []
	            },
	            {
	                "id": "student",
	                "label": "Students",
	                "url": "/students/list",
	                "type": "route",
	                "target": "",
	                "icon": "people",
	                "role": []
	            },
	            {
	                "id": "booking",
	                "label": "Bookings",
	                "url": "/booking/list",
	                "type": "route",
	                "target": "",
	                "icon": "bookmark",
	                "role": []
	            },
	            {
	                "id": "email",
	                "label": "Email",
	                "url": "/email/list",
	                "type": "route",
	                "target": "",
	                "icon": "mail",
	                "role": []
	            },
	            {
	                "id": "attendances",
	                "label": "Attendances",
	                "url": "/attendances",
	                "type": "route",
	                "target": "",
	                "icon": "spellcheck",
	                "role": []
	            }
	        ]
	    },
	    // Bus module parent sidebar list
	    {
	        name: 'bus-parent-sidebar',
	        menuList: [
	            {
	                "id": "bus-attendance",
	                "label": "Bus attendance",
	                "url": "",
	                "type": "route",
	                "target": "",
	                "icon": "store",
	                "role": []
	            },
	            {
	                "id": "bus-profile",
	                "label": "Profile",
	                "url": "",
	                "type": "route",
	                "target": "",
	                "icon": "people",
	                "role": []
	            }
	        ]
	    },
	    // Bus module parent sidebar list
	    {
	        name: 'bus-admin-sidebar',
	        menuList: [
	            {
	                "id": "bus-schedule",
	                "label": "Daily transport list",
	                "url": "dashboard",
	                "type": "route",
	                "target": "",
	                "icon": "directions_bus",
	                "role": ['system', 'manager']
	            },
	            {
	                "id": "bus-student-management",
	                "label": "Student report",
	                "url": "students/list",
	                "type": "route",
	                "target": "",
	                "icon": "assignment_ind",
	                "role": ['system']
	            },
	            {
	                "id": "bus-report",
	                "label": "Bus report",
	                "url": "report",
	                "type": "route",
	                "target": "",
	                "icon": "assessment",
	                "role": ['system']
	            },
	            {
	                "id": "bus-settings",
	                "label": "Settings",
	                "url": "settings",
	                "type": "route",
	                "target": "",
	                "icon": "settings",
	                "role": ['system']
	            }
	        ]
	    },
	    // Holiday module main menu list
	    {
	        name: "holiday-main",
	        menuList: []
	    },
	    // holiday module admin sidebar list
	    {
	        name: 'holiday-admin-sidebar',
	        menuList: [
	            {
	                "id": "booking",
	                "label": "Bookings",
	                "url": "/booking/list",
	                "type": "route",
	                "target": "",
	                "icon": "bookmark",
	                "role": ['system']
	            },
	            {
	                "id": "courses",
	                "label": "Courses",
	                "url": "/courses/list",
	                "type": "route",
	                "target": "",
	                "icon": "book",
	                "role": ['system']
	            },
	            {
	                "id": "classes",
	                "label": "Classes",
	                "url": "/classes/list",
	                "type": "route",
	                "target": "",
	                "icon": "store",
	                "role": ['system', 'manager']
	            },
	            {
	                "id": "student",
	                "label": "Students",
	                "url": "/students/list",
	                "type": "route",
	                "target": "",
	                "icon": "people",
	                "role": ['system']
	            },
	            {
	                "id": "email",
	                "label": "Email",
	                "url": "/email/list",
	                "type": "route",
	                "target": "",
	                "icon": "mail",
	                "role": ['system', 'manager']
	            },
	            {
	                "id": "attendances",
	                "label": "Attendances",
	                "url": "/attendances",
	                "type": "route",
	                "target": "",
	                "icon": "spellcheck",
	                "role": ['system', 'manager']
	            },
	            {
	                "id": "parents",
	                "label": "Parents",
	                "url": "/parents",
	                "type": "route",
	                "target": "",
	                "icon": "people",
	                "role": ['system']
	            },
	            {
	                "id": "setting",
	                "label": "Setting",
	                "url": "/setting",
	                "type": "route",
	                "target": "",
	                "icon": "widgets",
	                "role": ['system']
	            }
	        ]
	    },
	    {
	        name: 'holiday-staff-sidebar',
	        menuList: [
	            {
	                "id": "attendances",
	                "label": "Attendances",
	                "url": "/attendances",
	                "type": "route",
	                "target": "",
	                "icon": "spellcheck",
	                "role": []
	            },
	        ]
	    },
	    // Holiday parent sub menu
	    {
	        name: "holiday-sub",
	        menuList: [
	            {
	                "id": "holidayBooking",
	                "label": "Booking",
	                "url": "/booking/students",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "holidayAttendance",
	                "label": "Attendance",
	                "url": "/view-attendance",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // re-enrollment module admin sidebar list
	    {
	        name: 'reen-admin-sidebar',
	        menuList: [
	            {
	                "id": "response",
	                "label": "Responses",
	                "url": "/response/list",
	                "type": "route",
	                "target": "",
	                "icon": "bookmark",
	                "role": ['system']
	            },
	            {
	                "id": "email",
	                "label": "Email",
	                "url": "/email/list",
	                "type": "route",
	                "target": "",
	                "icon": "email",
	                "role": ['system']
	            },
	            {
	                "id": "student",
	                "label": "Students",
	                "url": "/reen-student",
	                "type": "route",
	                "target": "",
	                "icon": "store",
	                "role": ['system']
	            },
	            {
	                "id": "report",
	                "label": "Report",
	                "url": "/report",
	                "type": "route",
	                "target": "",
	                "icon": "assessment",
	                "role": ['system']
	            }
	        ]
	    },
	];


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CampusInfo = (function () {
	    function CampusInfo() {
	    }
	    return CampusInfo;
	}());
	exports.CampusInfo = CampusInfo;
	// Campus Info
	exports.CAMPUS_INFOS = [
	    {
	        "id": 1,
	        "name": "HELEN Campus",
	        "info": "F3 Block B Charmington La Pointe<br>181 Cao Thang<br>Wd.12 | District 10<br>HCMC | Vietnam<br>T: +84 28 6278 2628<br><br>info@nascorp.vn<br>www.nascorp.vn<br>"
	    },
	];


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var ApiService_1 = __webpack_require__(89);
	var SettingService_1 = __webpack_require__(91);
	var LocalNetworkService = (function () {
	    function LocalNetworkService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    LocalNetworkService.prototype.getLocalNetWork = function () {
	        this.hostName = window.location.hostname;
	        if (this.hostName === "auth.aisvietnam.com") {
	            var requestUrl = 'http://auth.aisvietnam.com/negotiate';
	            return this.apiService.get(requestUrl);
	        }
	        else {
	            var requestUrl = '/negotiate';
	            return this.apiService.get(requestUrl);
	        }
	    };
	    return LocalNetworkService;
	}());
	LocalNetworkService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService])
	], LocalNetworkService);
	exports.LocalNetworkService = LocalNetworkService;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuService_1 = __webpack_require__(99);
	var FooterComponent = (function () {
	    function FooterComponent(menuService) {
	        this.menuService = menuService;
	    }
	    FooterComponent.prototype.ngOnInit = function () {
	        /** TO DO
	         * Get current language from cookie/session
	         * If no language data from it, set default language as English
	         */
	        this.currentLang = 'en';
	        // Get top menu list
	        this.menuList = this.menuService.getMenuList('top');
	        // Get campus info list
	        this.campusList = this.menuService.getCampusInfo();
	    };
	    return FooterComponent;
	}());
	FooterComponent = __decorate([
	    core_1.Component({
	        selector: 'footer',
	        template: __webpack_require__(104),
	        styles: [__webpack_require__(108)],
	        providers: [MenuService_1.MenuService]
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService])
	], FooterComponent);
	exports.FooterComponent = FooterComponent;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"app-footer\">\n\t<div class=\"campus-info-list row small-up-1 medium-up-2 large-up-4\">\n\t\t<!-- Campus Information -->\n\t\t<div class=\"column\" *ngFor=\"let campus of campusList\">\n\t\t\t<h6 class=\"campus-title\">{{campus.name}}</h6>\n\t\t\t<div class=\"campus-text\" [innerHTML]=\"campus.info\"></div>\n\t\t</div>\n\t\t<!-- CIS Member -->\n\t\t<!-- <div class=\"column\">\n\t\t\t<p align=\"center\">\n\t\t\t\t<a href=\"http://www.ibo.org/\" target=\"_blank\"><img src=\"" + __webpack_require__(105) + "\"></a>\n\t\t\t</p>\n\t\t\t<p align=\"center\">\n\t\t\t\t<a href=\"https://www.cam.ac.uk/\" target=\"_blank\"><img src=\"" + __webpack_require__(106) + "\"></a>\n\t\t\t</p>\n\t\t\t<p align=\"center\" class=\"cis-membership\">\n\t\t\t\t<a href=\"http://www.cois.org/\" target=\"_blank\"><img src=\"" + __webpack_require__(107) + "\"></a>\n\t\t\t\t<br>\n\t\t\t</p>\n\t\t</div> -->\n\t</div>\n\t<!-- Bottom Bar -->\n\t<div class=\"bottom-bar\">\n\t\t<div class=\"copyright\">\n\t\t\t<span>Our website is best viewed using Chrome, Firefox, Safari.</span>\n\t\t</div>\n\t\t<!-- <div class=\"top-bar-right\">\n\t\t\t<ul class=\"menu\">\n\t\t\t\t<li *ngFor=\"let menu of menuList\">\n\t\t\t\t<a href=\"{{menu.url}}\" target=\"{{menu.target}}\">{{menu.label}}</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div> -->\n\t</div>\n</div>";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ib_logo.88ef45dabda5b2bbe32eb13597007f28.png";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cambridge_university_logo.7a6d3637e5c797cd2e49d2ed5ce219be.png";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cis_member_logo.a75e54c7e11c976905f137f41232cb3a.png";

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	module.exports = "#app-footer{background-color:#00707e;font-size:0.7rem;bottom:0;bottom-position:absolute;bottom-width:100%}#app-footer .campus-info-list{max-width:100%;padding:2rem 4rem}#app-footer .campus-info-list .column .campus-title{text-transform:uppercase;font-weight:500;font-size:1rem;color:#fff}#app-footer .campus-info-list .column .campus-text,#app-footer .campus-info-list .column .cis-membership{color:#dadada;line-height:1.375rem}#app-footer .bottom-bar{display:table;width:100%;background-color:#414042;padding:15px 4rem}#app-footer .bottom-bar .copyright{float:right;display:table-cell;vertical-align:middle}#app-footer .bottom-bar .copyright span{font-weight:500;color:#faa635}#app-footer .bottom-bar .top-bar-right{float:right}#app-footer .bottom-bar .top-bar-right .menu>li>a{color:#faa635;padding:0.6rem 0.3rem}#app-footer .bottom-bar .top-bar-right .menu>li>a:hover{color:#fff}@media only screen and (max-width: 40em){#app-footer{font-size:0.8rem}#app-footer .campus-info-list .column{padding:1rem 0}#app-footer .campus-info-list .column .campus-title{font-size:1rem}#app-footer .bottom-bar .copyright{padding:0.5rem;text-align:center}#app-footer .bottom-bar .top-bar-right{display:none}}\n"

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var MenuService_1 = __webpack_require__(99);
	var UserService_1 = __webpack_require__(110);
	var SessionService_1 = __webpack_require__(111);
	var router_1 = __webpack_require__(70);
	var HolidayService_1 = __webpack_require__(112);
	var services_1 = __webpack_require__(88);
	var AdminService_1 = __webpack_require__(113);
	var config_1 = __webpack_require__(114);
	var MainMenuComponent = (function () {
	    function MainMenuComponent(menuService, router, holidayService, userService, sessionService, sessionStorageService, adminService) {
	        this.menuService = menuService;
	        this.router = router;
	        this.holidayService = holidayService;
	        this.userService = userService;
	        this.sessionService = sessionService;
	        this.sessionStorageService = sessionStorageService;
	        this.adminService = adminService;
	        this.menuStatusChanged = new Subject_1.Subject();
	        this.userMenuClassVisible = 'menu-list-visible';
	    }
	    MainMenuComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.parent = new Object;
	        this.getSessionData();
	        this.hostName = window.location.hostname;
	        // Get main menu List
	        this.menuList = this.getMainMenuList();
	        //  Get sub menu list
	        this.subMenuList = this.getSubMenuList();
	        this.menuStatus = this.getMenuStatus();
	        // Subscription to catch the session changed to change the menu list content
	        this.subscription = this.userService.userDataChanged$.subscribe(function (user) {
	            _this.onSessionChanged(user);
	        });
	    };
	    MainMenuComponent.prototype.checkAccountIsVasParent = function () {
	        return this.sessionStorageService.getData('isVasParent');
	    };
	    MainMenuComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    /**
	     * Action that fired when the session change event is catched.
	     * Update the userData & the menuList.
	     */
	    MainMenuComponent.prototype.onSessionChanged = function (user) {
	        //TO DO: update menu content when session changed
	        this.userData = user;
	        // Get Menu List
	        this.menuList = this.getMainMenuList();
	        this.subMenuList = this.getSubMenuList();
	    };
	    MainMenuComponent.prototype.onMenuStatusChanged = function () {
	        this.menuStatus = this.getMenuStatus();
	    };
	    MainMenuComponent.prototype.getMenuStatus = function () {
	        if (document.URL === "http://" + config_1.devEnv.services + "/" ||
	            document.URL === "http://" + config_1.localEnv.services + "/" ||
	            document.URL === "http://" + config_1.testEnv.services + "/" ||
	            document.URL === "http://" + config_1.bisHanoiEnv.services + "/" ||
	            document.URL === "http://" + config_1.bisHanoiDevEnv.services + "/" ||
	            document.URL === "http://" + config_1.stagingEnv.services + "/" ||
	            document.URL === "https://" + config_1.procEnv.services + "/" ||
	            document.URL === "http://" + config_1.demoEnv.services + "/") {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    /**
	     * Return a module 's menu list content for the main menu.
	     * Return login main menu list if no user data is detected.
	     * @returns {Menu[]|[]} - module's menu list or empty list.
	     */
	    MainMenuComponent.prototype.getMainMenuList = function () {
	        var menuList = [];
	        if (!this.userData && (this.hostName === config_1.procEnv.holiday
	            || this.hostName === config_1.devEnv.holiday
	            || this.hostName === config_1.localEnv.holiday
	            || this.hostName === config_1.bisHanoiEnv.holiday
	            || this.hostName === config_1.bisHanoiDevEnv.holiday
	            || this.hostName === config_1.testEnv.holiday
	            || this.hostName === config_1.stagingEnv.holiday
	            || this.hostName === config_1.demoEnv.holiday)) {
	            menuList = this.menuService.getMenuList('hol-login');
	        }
	        else if (!this.userData) {
	            menuList = this.menuService.getMenuList('login-main');
	        }
	        else {
	            menuList = this.menuService.getMenuList(this.module + '-main');
	        }
	        return menuList;
	    };
	    /**
	     * Return a module 's SUB menu list content for the main menu.
	     * Return login main menu list if no user data is detected.
	     * @returns {Menu[]|[]} - module's menu list or empty list.
	     */
	    MainMenuComponent.prototype.getSubMenuList = function () {
	        return this.menuService.getMenuList(this.module + '-sub');
	    };
	    MainMenuComponent.prototype.toLogOut = function () {
	        this.userData = this.userService.getUserSessionData();
	        this.deleteSession();
	    };
	    /**
	 * Delete user session data.
	 */
	    MainMenuComponent.prototype.deleteSession = function () {
	        var _this = this;
	        this.sessionService.deleteSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.userService.clearUserSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.userService.userDataChanged(null);
	            // Redirect to desired URL                    
	            if (Object.values(config_1.devEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.services;
	            }
	            else if (Object.values(config_1.testEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.services;
	            }
	            else if (Object.values(config_1.procEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.services;
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.services;
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.services;
	            }
	        });
	    };
	    MainMenuComponent.prototype.getSessionData = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userData = user;
	            if (_this.userData.role !== 'system' && _this.userData.role !== 'manager') {
	                _this.getParent();
	            }
	        });
	    };
	    MainMenuComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL
	        if (this.userData.role === 'parent' || this.parent.type === 'vas') {
	            if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.services + "/parents";
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.services + "/parents";
	            }
	        }
	        // Redirect to desired URL
	        if (this.userData.role === 'hol-parent' || this.parent.type === 'other') {
	            if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.services + "/other-parents";
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.services + "/other-parents";
	            }
	        }
	        if (!this.userData && !this.parent) {
	            if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.services;
	            }
	            else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.services;
	            }
	            else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.services;
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.services;
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.services;
	            }
	        }
	    };
	    MainMenuComponent.prototype.toRegister = function () {
	        if (this.hostName === config_1.procEnv.holiday
	            || this.hostName === config_1.devEnv.holiday
	            || this.hostName === config_1.localEnv.holiday
	            || this.hostName === config_1.bisHanoiEnv.holiday
	            || this.hostName === config_1.bisHanoiDevEnv.holiday
	            || this.hostName === config_1.demoEnv.holiday) {
	            this.router.navigateByUrl('/hol-register');
	        }
	        else {
	            this.router.navigate(['/register']);
	        }
	    };
	    MainMenuComponent.prototype.toChangePassword = function () {
	        if (this.hostName === config_1.procEnv.holiday
	            || this.hostName === config_1.devEnv.holiday
	            || this.hostName === config_1.localEnv.holiday
	            || this.hostName === config_1.bisHanoiEnv.holiday
	            || this.hostName === config_1.bisHanoiDevEnv.holiday
	            || this.hostName === config_1.demoEnv.holiday) {
	            this.router.navigateByUrl('/hol-change-password');
	        }
	        else {
	            this.router.navigate(['/change-password']);
	        }
	    };
	    MainMenuComponent.prototype.menuStatusDataChanged = function (menu) {
	        this.menuStatusChanged.next(menu);
	    };
	    MainMenuComponent.prototype.getParent = function () {
	        var _this = this;
	        this.holidayService.getParent()
	            .subscribe(function (parent) {
	            _this.parent = parent;
	            if (_this.parent.status === "fill-info") {
	                _this.router.navigate(['/profile/add-parent']);
	            }
	            else if (_this.parent.status == "full") {
	                _this.router.navigate(['/booking/students']);
	            }
	            else {
	                _this.router.navigate(['/add-student']);
	            }
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    MainMenuComponent.prototype.toProfile = function () {
	        if (this.hostName === config_1.procEnv.holiday
	            || this.hostName === config_1.devEnv.holiday
	            || this.hostName === config_1.localEnv.holiday
	            || this.hostName === config_1.bisHanoiEnv.holiday
	            || this.hostName === config_1.bisHanoiDevEnv.holiday
	            || this.hostName === config_1.demoEnv.holiday) {
	            this.router.navigateByUrl('/profile/edit-parent');
	        }
	        else {
	            this.router.navigate(['/profile/edit-parent']);
	        }
	    };
	    return MainMenuComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], MainMenuComponent.prototype, "module", void 0);
	MainMenuComponent = __decorate([
	    core_1.Component({
	        selector: 'main-menu',
	        template: __webpack_require__(115),
	        styles: [__webpack_require__(117)],
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService,
	        router_1.Router,
	        HolidayService_1.HolidayService,
	        UserService_1.UserService,
	        SessionService_1.SessionService,
	        services_1.SessionStorageService,
	        AdminService_1.AdminService])
	], MainMenuComponent);
	exports.MainMenuComponent = MainMenuComponent;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var services_1 = __webpack_require__(88);
	var UserService = (function () {
	    function UserService(sessionStorageService) {
	        this.sessionStorageService = sessionStorageService;
	        // Observable User source
	        this.userDataChangedSource = new Subject_1.Subject();
	        // Observable User streams
	        this.userDataChanged$ = this.userDataChangedSource.asObservable();
	    }
	    UserService.prototype.getUserSessionData = function () {
	        return this.sessionStorageService.getData('eca-user');
	    };
	    UserService.prototype.setUserSessionData = function (user) {
	        return this.sessionStorageService.setData('eca-user', user);
	    };
	    UserService.prototype.clearUserSessionData = function () {
	        return this.sessionStorageService.removeData('eca-user');
	    };
	    UserService.prototype.userDataChanged = function (user) {
	        this.userDataChangedSource.next(user);
	    };
	    return UserService;
	}());
	UserService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SessionStorageService])
	], UserService);
	exports.UserService = UserService;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var services_1 = __webpack_require__(88);
	var SessionService = (function () {
	    function SessionService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.sessionUrl = '/session';
	        this.cafeteriaUrl = '/caterer-service/';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get Session from API
	     * @params: none
	     * @return: status 200 - User observable object if session is provied succesfully.
	     *          status 401 - Unauthorized if user credentials are invalid.
	     * */
	    SessionService.prototype.getSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get Session from API
	     * @params: User Observable Object
	     * @return: status 200 - User observable object if session is created.
	     *          status 401 - Unauthorized if no session is found.
	     * */
	    SessionService.prototype.postSession = function (credential) {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        var body = JSON.stringify({
	            'role': credential.role,
	            'email': credential.email,
	            'password': credential.password
	        });
	        // Call Get Method from Api Service
	        return this.apiService.post(requestUrl, body);
	    };
	    SessionService.prototype.deleteSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        return this.apiService.delete(requestUrl);
	    };
	    SessionService.prototype.getCafeteriaUrl = function () {
	        var requestUrl = this.apiUrl + this.cafeteriaUrl + 'daisyLink';
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    SessionService.prototype.getSessionDaisy = function () {
	        var requestUrl = this.apiUrl + this.cafeteriaUrl + 'getTokenByCookie';
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    return SessionService;
	}());
	SessionService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], SessionService);
	exports.SessionService = SessionService;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(88);
	var HolidayService = (function () {
	    function HolidayService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        this.courseUrl = '/hol/course';
	        this.courseClassUrl = '/hol/class/';
	        this.courseStudentUrl = '/hol/student/';
	        this.parentUrl = '/hol/parent';
	        this.convertParentUrl = '/hol/parent/convert';
	        this.parentPassword = '/hol/parent/password';
	        this.weekUrl = '/hol/week';
	        this.excursionUrl = '/hol/excursion';
	        this.questionnarie = "/hol/questionnaire";
	        this.parentEmail = '/hol/parent/email';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    HolidayService.prototype.createCourse = function (courseItem) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        // Post content
	        var body = JSON.stringify(courseItem);
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.createCourseClass = function (courseClassItem) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        // Post content
	        var body = JSON.stringify(courseClassItem);
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.getCourseList = function (filter) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getCourseDetail = function (courseId) {
	        var requestUrl = this.apiUrl + this.courseUrl + '?id=' + courseId;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getFullCourseList = function () {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.editCourse = function (courseItem) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        var body = JSON.stringify({
	            id: courseItem.id,
	            name: courseItem.name,
	            type: courseItem.type,
	            school_year: courseItem.school_year,
	            start_date: courseItem.start_date,
	            end_date: courseItem.end_date,
	            description: courseItem.description,
	            status: courseItem.status
	        });
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.updateParent = function (nonVasParent) {
	        var requestUrl = this.apiUrl + this.parentUrl;
	        var body = JSON.stringify(nonVasParent);
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.getParent = function (filter) {
	        if (filter === void 0) { filter = []; }
	        var requestUrl = this.apiUrl + this.parentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.changeParentPassword = function (query) {
	        var requestUrl = this.apiUrl + this.parentPassword;
	        var body = JSON.stringify(query);
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.changeParentEmail = function (query) {
	        var requestUrl = this.apiUrl + this.parentEmail;
	        var body = JSON.stringify(query);
	        return this.apiService.put(requestUrl, body);
	    };
	    HolidayService.prototype.convertParent = function () {
	        var requestUrl = this.apiUrl + this.convertParentUrl;
	        var body = JSON.stringify({});
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.getCourseClassList = function (filter) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getClassDetail = function (classId) {
	        var requestUrl = this.apiUrl + this.courseClassUrl + '?id=' + classId + '&page=1';
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getFullCourseClassList = function () {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.editClass = function (classItem) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        var body = JSON.stringify({
	            id: classItem.id,
	            thumbnail_id: classItem.thumbnail_id,
	            name: classItem.name,
	            room: classItem.room,
	            campus_id: classItem.campus_id,
	            teacher: classItem.teacher,
	            max_number: classItem.max_number,
	            suitable_from: classItem.suitable_from,
	            suitable_to: classItem.suitable_to,
	            total_cost: +classItem.total_cost,
	            cost_per_week: classItem.cost_per_week,
	            activities: classItem.activities,
	            status: classItem.status,
	            prices: classItem.prices
	        });
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Get week
	    HolidayService.prototype.getWeekService = function () {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        return this.apiService.get(requestUrl);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Add week
	    HolidayService.prototype.addWeekService = function (weeks) {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        var body = JSON.stringify(weeks);
	        return this.apiService.post(requestUrl, body);
	    };
	    //Edit week
	    HolidayService.prototype.editWeekService = function (weeks) {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        var body = JSON.stringify(weeks);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Get excursion
	    HolidayService.prototype.getExcursionService = function (filter) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Add excursion
	    HolidayService.prototype.addExcursionService = function (excursion) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var body = JSON.stringify(excursion);
	        return this.apiService.post(requestUrl, body);
	    };
	    //Edit week
	    HolidayService.prototype.editExcursionService = function (excursion) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var body = JSON.stringify(excursion);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Remove student in class
	    HolidayService.prototype.removeStudentInClass = function (studentId, classId) {
	        var requestUrl = this.apiUrl + this.courseStudentUrl + studentId + '/class/' + classId;
	        var body = {
	            "holStudentId": studentId,
	            "holClassId": classId
	        };
	        return this.apiService.deletePost(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Transfer waiting student in class
	    HolidayService.prototype.transferStudentInClass = function (studentId, classId, status) {
	        var requestUrl = this.apiUrl + this.courseClassUrl + classId + '/student/' + studentId;
	        var body = {
	            "holStudentId": studentId,
	            "holClassId": classId,
	            "status": status
	        };
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.getParentById = function (id) {
	        var requestUrl = this.apiUrl + this.parentUrl + '/' + id;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getQuestionnarie = function () {
	        var requestUrl = this.apiUrl + this.questionnarie;
	        return this.apiService.get(requestUrl);
	    };
	    ;
	    HolidayService.prototype.getQuestionnarieById = function (id) {
	        var requestUrl = this.apiUrl + this.questionnarie + '/' + id;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.upsertQuestionnarie = function (question) {
	        var body = JSON.stringify(question);
	        var requestUrl = this.apiUrl + this.questionnarie;
	        return this.apiService.put(requestUrl, body);
	    };
	    ;
	    return HolidayService;
	}());
	HolidayService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], HolidayService);
	exports.HolidayService = HolidayService;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var services_1 = __webpack_require__(88);
	var AdminService = (function () {
	    function AdminService(sessionStorageService) {
	        this.sessionStorageService = sessionStorageService;
	        this.adminDataChangedSource = new Subject_1.Subject();
	        this.logger = new Subject_1.Subject();
	        // Observable Admin streams
	        this.adminDataChanged$ = this.adminDataChangedSource.asObservable();
	    }
	    AdminService.prototype.getAdminSessionData = function () {
	        return this.sessionStorageService.getData('asa-admin');
	    };
	    AdminService.prototype.setAdminSessionData = function (admin) {
	        return this.sessionStorageService.setData('asa-admin', admin);
	    };
	    AdminService.prototype.clearAdminSessionData = function () {
	        return this.sessionStorageService.removeData('asa-admin');
	    };
	    AdminService.prototype.clearInterSession = function () {
	        return this.sessionStorageService.removeData('curId');
	    };
	    AdminService.prototype.adminDataChanged = function (admin) {
	        return this.adminDataChangedSource.next(admin);
	    };
	    return AdminService;
	}());
	AdminService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SessionStorageService])
	], AdminService);
	exports.AdminService = AdminService;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//VAS
	var schoolUrl = 'demo';
	exports.devEnv = {
	    services: "services." + schoolUrl + ".dev.nascorp.vn",
	    auth: "auth." + schoolUrl + ".dev.nascorp.vn",
	    camp: "camp." + schoolUrl + ".dev.nascorp.vn",
	    asa: "asa." + schoolUrl + ".dev.nascorp.vn",
	    holiday: "holiday." + schoolUrl + ".dev.nascorp.vn",
	    bus: "bus." + schoolUrl + ".dev.nascorp.vn",
	    conference: "conference." + schoolUrl + ".dev.nascorp.vn",
	    reen: "reen." + schoolUrl + ".dev.nascorp.vn",
	    event: "event." + schoolUrl + ".dev.nascorp.vn"
	};
	exports.testEnv = {
	    services: "services." + schoolUrl + ".test.nascorp.vn",
	    auth: "auth." + schoolUrl + ".test.nascorp.vn",
	    camp: "camp." + schoolUrl + ".test.nascorp.vn",
	    asa: "asa." + schoolUrl + ".test.nascorp.vn",
	    holiday: "holiday." + schoolUrl + ".test.nascorp.vn",
	    bus: "bus." + schoolUrl + ".test.nascorp.vn",
	    conference: "conference." + schoolUrl + ".test.nascorp.vn",
	    reen: "reen." + schoolUrl + ".test.nascorp.vn",
	    event: "event." + schoolUrl + ".test.nascorp.vn"
	};
	exports.procEnv = {
	    services: "ppservices." + schoolUrl + ".edu.vn",
	    auth: "ppauth." + schoolUrl + ".edu.vn",
	    camp: "ppcamp." + schoolUrl + ".edu.vn",
	    asa: "ppasa." + schoolUrl + ".edu.vn",
	    holiday: "ppholiday." + schoolUrl + ".edu.vn",
	    bus: "ppbus." + schoolUrl + ".edu.vn",
	    conference: "ppconference." + schoolUrl + ".edu.vn",
	    reen: "ppreen." + schoolUrl + ".edu.vn",
	    event: "ppevent." + schoolUrl + ".edu.vn"
	};
	exports.stagingEnv = {
	    auth: "ppuauth." + schoolUrl + ".edu.vn",
	    services: "ppuservices." + schoolUrl + ".edu.vn",
	    asa: "ppuasa." + schoolUrl + ".edu.vn",
	    holiday: "ppuholiday." + schoolUrl + ".edu.vn",
	    bus: "ppubus." + schoolUrl + ".edu.vn",
	    camp: "ppucamp." + schoolUrl + ".edu.vn",
	    reen: "ppureen." + schoolUrl + ".edu.vn",
	    conference: "ppuconference." + schoolUrl + ".edu.vn",
	    event: "ppuevent." + schoolUrl + ".edu.vn",
	};
	exports.localEnv = {
	    services: "services.local." + schoolUrl + ".dev.nascorp.vn",
	    auth: "auth.local." + schoolUrl + ".dev.nascorp.vn",
	    camp: "camp.local." + schoolUrl + ".dev.nascorp.vn",
	    asa: "asa.local." + schoolUrl + ".dev.nascorp.vn",
	    holiday: "holiday.local." + schoolUrl + ".dev.nascorp.vn",
	    bus: "bus.local." + schoolUrl + ".dev.nascorp.vn",
	    conference: "conference.local." + schoolUrl + ".dev.nascorp.vn",
	    reen: "reen.local." + schoolUrl + ".dev.nascorp.vn",
	    event: "event.local." + schoolUrl + ".dev.nascorp.vn",
	};
	exports.demoEnv = {
	    services: "services.demo.nascorp.vn",
	    auth: "auth.demo.nascorp.vn",
	    camp: "camp.demo.nascorp.vn",
	    asa: "asa.demo.nascorp.vn",
	    holiday: "holiday.demo.nascorp.vn",
	    bus: "bus.demo.nascorp.vn",
	    conference: "conference.demo.nascorp.vn",
	    reen: "reen.demo.nascorp.vn",
	    event: "event.demo.nascorp.vn",
	};
	exports.bisHanoiEnv = {
	    services: "services.bishanoi.nascorp.vn",
	    auth: "auth.bishanoi.nascorp.vn",
	    camp: "camp.bishanoi.nascorp.vn",
	    asa: "asa.bishanoi.nascorp.vn",
	    holiday: "holiday.bishanoi.nascorp.vn",
	    bus: "bus.bishanoi.nascorp.vn",
	    conference: "conference.bishanoi.nascorp.vn",
	    reen: "reen.bishanoi.nascorp.vn",
	    event: "event.bishanoi.nascorp.vn",
	};
	exports.bisHanoiDevEnv = {
	    services: "services.bishanoi.dev.nascorp.vn",
	    auth: "auth.bishanoi.dev.nascorp.vn",
	    camp: "camp.bishanoi.dev.nascorp.vn",
	    asa: "asa.bishanoi.dev.nascorp.vn",
	    holiday: "holiday.bishanoi.dev.nascorp.vn",
	    bus: "bus.bishanoi.dev.nascorp.vn",
	    conference: "conference.bishanoi.dev.nascorp.vn",
	    reen: "reen.bishanoi.dev.nascorp.vn",
	    event: "event.bishanoi.dev.nascorp.vn",
	};
	exports.bisHanoiStagingEnv = {
	    services: "services.bishanoistaging.nascorp.vn",
	    auth: "auth.bishanoistaging.nascorp.vn",
	    camp: "camp.bishanoistaging.nascorp.vn",
	    asa: "asa.bishanoistaging.nascorp.vn",
	    holiday: "holiday.bishanoistaging.nascorp.vn",
	    bus: "bus.bishanoistaging.nascorp.vn",
	    conference: "conference.bishanoistaging.nascorp.vn",
	    reen: "reen.bishanoistaging.nascorp.vn",
	    event: "event.bishanoistaging.nascorp.vn",
	};
	exports.ishcmcEnv = {
	    services: "services.ishcmc.nascorp.vn",
	    auth: "auth.ishcmc.nascorp.vn",
	    camp: "camp.ishcmc.nascorp.vn",
	    asa: "asa.ishcmc.nascorp.vn",
	    holiday: "holiday.ishcmc.nascorp.vn",
	    bus: "bus.ishcmc.nascorp.vn",
	    conference: "conference.ishcmc.nascorp.vn",
	    reen: "reen.ishcmc.nascorp.vn",
	    event: "event.ishcmc.nascorp.vn",
	};
	exports.aavnIshcmcEnv = {
	    services: "services.aavn.ishcmc.nascorp.vn",
	    auth: "auth.aavn.ishcmc.nascorp.vn",
	    camp: "camp.aavn.ishcmc.nascorp.vn",
	    asa: "asa.aavn.ishcmc.nascorp.vn",
	    holiday: "holiday.aavn.ishcmc.nascorp.vn",
	    bus: "bus.aavn.ishcmc.nascorp.vn",
	    conference: "conference.aavn.ishcmc.nascorp.vn",
	    reen: "reen.aavn.ishcmc.nascorp.vn",
	    event: "event.aavn.ishcmc.nascorp.vn",
	};
	exports.primaryIshcmcEnv = {
	    services: "services.primary.ishcmc.nascorp.vn",
	    auth: "auth.primary.ishcmc.nascorp.vn",
	    camp: "camp.primary.ishcmc.nascorp.vn",
	    asa: "asa.primary.ishcmc.nascorp.vn",
	    holiday: "holiday.primary.ishcmc.nascorp.vn",
	    bus: "bus.primary.ishcmc.nascorp.vn",
	    conference: "conference.primary.ishcmc.nascorp.vn",
	    reen: "reen.primary.ishcmc.nascorp.vn",
	    event: "event.primary.ishcmc.nascorp.vn",
	};
	exports.secondaryIshcmcEnv = {
	    services: "services.secondary.ishcmc.nascorp.vn",
	    auth: "auth.secondary.ishcmc.nascorp.vn",
	    camp: "camp.secondary.ishcmc.nascorp.vn",
	    asa: "asa.secondary.ishcmc.nascorp.vn",
	    holiday: "holiday.secondary.ishcmc.nascorp.vn",
	    bus: "bus.secondary.ishcmc.nascorp.vn",
	    conference: "conference.secondary.ishcmc.nascorp.vn",
	    reen: "reen.secondary.ishcmc.nascorp.vn",
	    event: "event.secondary.ishcmc.nascorp.vn",
	};
	exports.isspEnv = {
	    services: "services.issp.nascorp.vn",
	    auth: "auth.issp.nascorp.vn",
	    camp: "camp.issp.nascorp.vn",
	    asa: "asa.issp.nascorp.vn",
	    holiday: "holiday.issp.nascorp.vn",
	    bus: "bus.issp.nascorp.vn",
	    conference: "conference.issp.nascorp.vn",
	    reen: "reen.issp.nascorp.vn",
	    event: "event.issp.nascorp.vn",
	};
	exports.demoHelenEnv = {
	    services: "services.demo.helen.edu.vn",
	    auth: "auth.demo.helen.edu.vn",
	    camp: "camp.demo.helen.edu.vn",
	    asa: "asa.demo.helen.edu.vn",
	    holiday: "holiday.demo.helen.edu.vn",
	    bus: "bus.demo.helen.edu.vn",
	    conference: "conference.demo.helen.edu.vn",
	    reen: "reen.demo.helen.edu.vn",
	    event: "event.demo.helen.edu.vn",
	};
	exports.demoJeduEnv = {
	    services: "services.demo.jedu.edu.vn",
	    auth: "auth.demo.jedu.edu.vn",
	    camp: "camp.demo.jedu.edu.vn",
	    asa: "asa.demo.jedu.edu.vn",
	    holiday: "holiday.demo.jedu.edu.vn",
	    bus: "bus.demo.jedu.edu.vn",
	    conference: "conference.demo.jedu.edu.vn",
	    reen: "reen.demo.jedu.edu.vn",
	    event: "event.demo.jedu.edu.vn",
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"app-main-menu\">\n\t<!-- Hamburger Menu -->\n\t<div class=\"hamburger-menu\">\n\t\t<a href=\"#\">\n\t\t\t<i class=\"material-icons\">menu</i>\n\t\t</a>\n\t</div>\n\t<div class=\"container\">\n\t\t<div class=\"top-bar\">\n\t\t\t<!--Top bar left-->\n\t\t\t<div class=\"top-bar-left\">\n\t\t\t\t<!-- Logo -->\n\t\t\t\t<div class=\"logo\">\n\t\t\t\t\t<a (click)=\"toHomePage()\"><img src=\"" + __webpack_require__(116) + "\"></a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!--End of Top bar left-->\n\n\t\t\t<!--Top bar right-->\n\t\t\t<div class=\"top-bar-right\">\n\t\t\t\t<!-- Menu Items -->\n\t\t\t\t<div class=\"main-right-menu\">\n\t\t\t\t\t<ul class=\"menu\" *ngIf=\"menuStatus\">\n\t\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t\t<li *ngFor=\"let menu of menuList;\">\n\t\t\t\t\t\t\t<div *ngIf=\"!userData\">\n\t\t\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<!-- Show user menu item if have user data from session -->\n\t\t\t\t\t\t<li *ngIf=\"userData\" class=\"user-profile-menu\" [menuHover]=\"userMenuClassVisible\">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<a>\n\t\t\t\t\t\t\t\t\t<span>Hi, {{userData.name.split('@')[0]}}</span>\n\t\t\t\t\t\t\t\t\t<i class=\"material-icons\">keyboard_arrow_down</i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<ul class=\"\">\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"toChangePassword()\">Change Password</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li *ngIf=\"!checkAccountIsVasParent()\">\n\t\t\t\t\t\t\t\t\t<a (click)=\"toProfile()\">Profile</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"toLogOut()\">Logout</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t\t<!--New sub menu for module-->\n\t\t\t\t<ul class=\"sub-menu\" *ngIf=\"userData\" >\n\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t<li *ngFor=\"let menu of subMenuList\">\n\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<!--End of sub menu-->\n\t\t\t</div>\n\t\t\t<!--End of top bar right-->\n\t\t</div>\n\t\t<!--End of top bar-->\n\t</div>\n</div>";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/helen-logo.04cf3a7917571dd46d711c96e16a5ed6.png";

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = "#app-main-menu{background-color:#00707e;position:relative}#app-main-menu .hamburger-menu{display:none}#app-main-menu .top-bar{background:transparent;padding:0}#app-main-menu .top-bar .top-bar-left{flex:0.5 0.5 0px;background-color:#00707e;height:100%}#app-main-menu .top-bar .top-bar-left .logo{height:100%;display:flex;align-items:center;justify-content:flex-start}#app-main-menu .top-bar .top-bar-right{padding-top:1rem}#app-main-menu .logo>a{display:inline-block}#app-main-menu .logo>a img{height:116px}#app-main-menu .sub-menu{float:right;background:transparent;font-size:0.9rem}#app-main-menu .sub-menu li{list-style:none;display:inline-block;text-transform:uppercase}#app-main-menu .sub-menu li a{display:block;color:#fff;padding:0.5rem;margin:0 0.3rem}#app-main-menu .sub-menu li a.active{border-bottom:solid 2px #ffae00}#app-main-menu .main-right-menu{float:right}#app-main-menu .main-right-menu .menu{background-color:#00707e}#app-main-menu .main-right-menu .menu>li>div>a{padding:0.5rem 1rem;border-radius:0.2rem;margin-left:1rem;min-width:6.25rem;border:1px solid #00707e;color:#fff;text-align:center}#app-main-menu .main-right-menu .menu>li>div>a:hover,#app-main-menu .main-right-menu .menu>li>div>a.active{background-color:#faa635;border:1px solid #faa635;color:#00707e;border:1px solid #00707e}#app-main-menu .main-right-menu .menu>li>div>a>i{margin:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu{position:relative}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a{margin-bottom:0.5rem;line-height:23px;display:inline-block;padding-top:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a span{display:inline-block}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a i{display:inline-block;position:relative;top:6px}#app-main-menu .main-right-menu .menu>li.user-profile-menu>ul{list-style:none;border-radius:0.2rem;position:absolute;z-index:2;right:0;width:130%;display:none}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul{display:block;box-shadow:0 8px 10px 1px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0,0,0,0.2)}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a{display:block;padding:0.4rem 1rem;border-radius:0.2rem}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a:hover{background-color:#faa635;color:#00707e}@media only screen and (max-width: 40em){#app-main-menu{height:auto;min-height:4rem}#app-main-menu .hamburger-menu{position:absolute;display:none;left:0;top:50%;transform:translateY(-50%);-ms-transform:translateY(-50%);-webkit-transform:translateY(-50%)}#app-main-menu .hamburger-menu>a{color:#fff;font-size:2rem}#app-main-menu .hamburger-menu>a>i{padding:1rem}#app-main-menu .logo{padding:0.4rem;margin:0 auto}#app-main-menu .logo>a{margin:0 auto;min-height:3rem}#app-main-menu .main-right-menu{display:none}#app-main-menu .top-bar-left{flex:none !important}}\n"

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuService_1 = __webpack_require__(99);
	var TopMenuComponent = (function () {
	    function TopMenuComponent(menuService) {
	        this.menuService = menuService;
	    }
	    TopMenuComponent.prototype.ngOnInit = function () {
	        /** TO DO
	         * Get current language from cookie/session
	         * If no language data from it, set default language as English
	         */
	        this.currentLang = 'en';
	        // Get Top Menu List
	        this.menuList = this.menuService.getMenuList('top');
	        // Get Social Connect Menu List
	        this.socialMenuList = this.menuService.getMenuList('social-top');
	    };
	    return TopMenuComponent;
	}());
	TopMenuComponent = __decorate([
	    core_1.Component({
	        selector: 'top-menu',
	        template: __webpack_require__(119),
	        styles: [__webpack_require__(120)],
	        providers: [
	            MenuService_1.MenuService
	        ]
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService])
	], TopMenuComponent);
	exports.TopMenuComponent = TopMenuComponent;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"app-top-menu\" class=\"top-bar\">\n    <!-- Left Menu List -->\n\t<div class=\"top-bar-left\" *ngIf=\"currentLang=='en'\">\n\t\t<ul class=\"menu\">\n\t\t\t<li *ngFor=\"let menu of menuList\">\n\t\t\t\t<a href=\"{{menu.url}}\" target=\"{{menu.target}}\">{{menu.label}}</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<!-- Right Menu List -->\n\t<div class=\"top-bar-right\">\n\t\t<ul class=\"menu\">\n\t\t\t<li *ngFor=\"let sMenu of socialMenuList\">\n\t\t\t\t<a href=\"{{sMenu.url}}\" target=\"{{sMenu.target}}\">\n\t\t\t\t<i class=\"fa fa-{{sMenu.id}}\"></i></a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</div>";

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports = "#app-top-menu{background-color:#064180;padding:0rem 4rem}#app-top-menu .menu{background-color:#064180}#app-top-menu .menu>li>a{padding:0.5rem;color:#fff}#app-top-menu .menu>li>a:hover{color:#faa635}#app-top-menu .top-bar-left .menu>li>a{padding:0.6rem 0.3rem;font-size:0.8rem}#app-top-menu .top-bar-right{flex:0 0 0px !important}@media only screen and (max-width: 40em){#app-top-menu{padding:0;overflow-x:hidden}#app-top-menu .menu{height:0}}\n"

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuHoverDirective = (function () {
	    function MenuHoverDirective(el, renderer) {
	        this.el = el;
	        this.renderer = renderer;
	    }
	    MenuHoverDirective.prototype.onMouseEnter = function () {
	        this.setClass(this.className, true);
	    };
	    MenuHoverDirective.prototype.onMouseLeave = function () {
	        this.setClass(this.className, false);
	    };
	    MenuHoverDirective.prototype.setClass = function (className, isAdd) {
	        this.renderer.setElementClass(this.el.nativeElement, className, isAdd);
	    };
	    return MenuHoverDirective;
	}());
	__decorate([
	    core_1.Input('menuHover'),
	    __metadata("design:type", String)
	], MenuHoverDirective.prototype, "className", void 0);
	__decorate([
	    core_1.HostListener('mouseenter'),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", []),
	    __metadata("design:returntype", void 0)
	], MenuHoverDirective.prototype, "onMouseEnter", null);
	__decorate([
	    core_1.HostListener('mouseleave'),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", []),
	    __metadata("design:returntype", void 0)
	], MenuHoverDirective.prototype, "onMouseLeave", null);
	MenuHoverDirective = __decorate([
	    core_1.Directive({
	        selector: '[menuHover]'
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
	], MenuHoverDirective);
	exports.MenuHoverDirective = MenuHoverDirective;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(70);
	var AdminService_1 = __webpack_require__(113);
	var SessionService_1 = __webpack_require__(123);
	var config_1 = __webpack_require__(114);
	var $ = __webpack_require__(124);
	var AdminHeaderComponent = (function () {
	    // For logout navigate
	    function AdminHeaderComponent(adminService, sessionService, router) {
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.router = router;
	        // For change password
	        this.isShow = false;
	        this.isShowChangePassword = false;
	        this.oldPassword = "";
	        this.newPassword = "";
	        this.confirmPassword = "";
	        this.isOPassWrong = false;
	        this.oPassCheck = '';
	        //message
	        this.msgs = [];
	    }
	    AdminHeaderComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        this.hostName = window.location.hostname;
	        this.headerName = this.getHeaderName(this.module);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	        // Get Admin session
	        this.adminData = this.adminService.getAdminSessionData();
	    };
	    AdminHeaderComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    AdminHeaderComponent.prototype.showDropDown = function () {
	        this.isShow = !this.isShow;
	    };
	    //on click outside,close div 
	    AdminHeaderComponent.prototype.onClickOutside = function (event) {
	        if (event && event['value'] === true) {
	            this.isShow = false;
	        }
	    };
	    AdminHeaderComponent.prototype.changePassword = function () {
	        this.isShowChangePassword = !this.isShowChangePassword;
	    };
	    AdminHeaderComponent.prototype.onSubmitChangePassword = function (myForm) {
	        var adminPassword = {
	            role: this.adminData.role,
	            username: this.adminData.name,
	            password: {
	                old: this.oldPassword,
	                new: this.newPassword
	            }
	        };
	        this.postPassword(adminPassword, myForm);
	    };
	    AdminHeaderComponent.prototype.onCloseChangePassword = function (myForm) {
	        this.clearPass();
	        myForm.resetForm();
	    };
	    /**
	    * Post password to change admin ldap password
	    * @param {adminPassword} - admin credential input
	    * @return none
	    */
	    AdminHeaderComponent.prototype.postPassword = function (adminPassword, myForm) {
	        var _this = this;
	        this.sessionService.changeAdminPassword(adminPassword)
	            .subscribe(function (result) {
	            _this.isShowChangePassword = false;
	            _this.clearPass();
	            //reset form state
	            myForm.resetForm();
	            _this.msgs.push({
	                severity: 'success',
	                summary: 'Success',
	                detail: 'Password has been updated'
	            });
	        }, function (err) {
	            _this.oPassCheck = _this.oldPassword;
	            if (err.status == 401) {
	                _this.isOPassWrong = true;
	                //focus old password
	                setTimeout(function () {
	                    $('#opass').focus();
	                }, 10);
	            }
	            else {
	                _this.msgs.push({
	                    severity: 'error',
	                    summary: 'Error',
	                    detail: 'Something went wrong. Please try again'
	                });
	            }
	        });
	    };
	    AdminHeaderComponent.prototype.clearPass = function () {
	        this.oldPassword = '';
	        this.newPassword = '';
	        this.confirmPassword = '';
	    };
	    AdminHeaderComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	        this.sidebarStatus = this.getSidebarStatus();
	    };
	    AdminHeaderComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	        });
	    };
	    AdminHeaderComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL                    
	        if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.devEnv.services;
	        }
	        else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.demoEnv.services;
	        }
	        else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	        }
	        else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	        }
	        else if (Object.values(config_1.bisHanoiStagingEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.bisHanoiStagingEnv.services;
	        }
	        else if (Object.values(config_1.ishcmcEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.ishcmcEnv.services;
	        }
	        else if (Object.values(config_1.aavnIshcmcEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.aavnIshcmcEnv.services;
	        }
	        else if (Object.values(config_1.primaryIshcmcEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.primaryIshcmcEnv.services;
	        }
	        else if (Object.values(config_1.secondaryIshcmcEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.secondaryIshcmcEnv.services;
	        }
	        else if (Object.values(config_1.isspEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.isspEnv.services;
	        }
	        else if (Object.values(config_1.demoHelenEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.demoHelenEnv.services;
	        }
	        else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.testEnv.services;
	        }
	        else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.stagingEnv.services;
	        }
	        else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.procEnv.services;
	        }
	        else {
	            return window.location.href = "http://" + config_1.localEnv.services;
	        }
	    };
	    // Detect sidebar vibibility
	    AdminHeaderComponent.prototype.getSidebarStatus = function () {
	        return !this.adminData ? false : true;
	    };
	    AdminHeaderComponent.prototype.getHeaderName = function (moduleName) {
	        var headerName = "";
	        switch (this.module) {
	            case "camp":
	                headerName = "Camp Programmes Management";
	                break;
	            case "asa":
	                headerName = "After School Activities Management";
	                break;
	            case "bus":
	                headerName = "Bus Programmes Management";
	            case "reen":
	                headerName = "";
	            default:
	                break;
	        }
	        return headerName;
	    };
	    // Log our function
	    AdminHeaderComponent.prototype.deleteSession = function () {
	        var _this = this;
	        // console.log(this.hostName)
	        this.module = 'auth';
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            // Fire user session data changed event
	            _this.adminService.adminDataChanged(null);
	            // Redirect to desired URL
	            if (Object.values(config_1.devEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.bisHanoiStagingEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiStagingEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.ishcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.ishcmcEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.aavnIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.aavnIshcmcEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.primaryIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.primaryIshcmcEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.secondaryIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.secondaryIshcmcEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.isspEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.isspEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.demoHelenEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoHelenEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.testEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.procEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.auth + "/login";
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.auth + "/login";
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    return AdminHeaderComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminHeaderComponent.prototype, "module", void 0);
	AdminHeaderComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-header',
	        template: __webpack_require__(125),
	        styles: [__webpack_require__(127)]
	    }),
	    __metadata("design:paramtypes", [AdminService_1.AdminService,
	        SessionService_1.SessionService,
	        router_1.Router])
	], AdminHeaderComponent);
	exports.AdminHeaderComponent = AdminHeaderComponent;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var services_1 = __webpack_require__(88);
	var SessionService = (function () {
	    function SessionService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.sessionUrl = '/session';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    SessionService.prototype.getSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    SessionService.prototype.postAdminSession = function (adminCredential) {
	        var requestUrl = '/ldap?' + 'username=' + adminCredential.username + '&password=' + adminCredential.password;
	        var body = JSON.stringify({
	            'role': adminCredential.role,
	            'username': adminCredential.username,
	            'password': adminCredential.password
	        });
	        // Call Get Method from Api Service
	        return this.apiService.post(requestUrl, body);
	    };
	    SessionService.prototype.deleteAdminSession = function () {
	        // const requestUrl = 'http://auth.eca.nascorp.vn/logout';
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        return this.apiService.delete(requestUrl);
	    };
	    SessionService.prototype.changeAdminPassword = function (adminPassword) {
	        var requestUrl = this.apiUrl + '/ldap-change-password';
	        var body = JSON.stringify({
	            'username': adminPassword.username,
	            'oldPassword': adminPassword.password.old,
	            'newPassword': adminPassword.password.new,
	        });
	        // Call Get Method from Api Service
	        return this.apiService.post(requestUrl, body);
	    };
	    return SessionService;
	}());
	SessionService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], SessionService);
	exports.SessionService = SessionService;


/***/ }),
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"header row\">\n    <h1 class=\"large-2\"><img style=\"width: 100px;\" src=\"" + __webpack_require__(126) + "\" /></h1>\n    <div class=\"header-info large-10\">\n        <div class=\"component-name\">\n            <h3>{{headerName}}</h3>\n        </div>\n\n        <!-- Logout for module Bus : -->\n        <div *ngIf=\"module == 'bus'\">\n            <div\n                *ngIf=\"adminData\"\n                click-outside\n                (clickOutside)=\"onClickOutside($event)\"\n                class=\"dropdown\"\n                (click)=\"showDropDown()\"\n            >\n                <a class=\"dropbtn\">{{ adminData.name }}</a>\n                <i class=\"material-icons\">arrow_drop_down</i>\n                <div *ngIf=\"isShow\" class=\"dropdown-content\">\n                    <a (click)=\"changePassword()\"\n                        >{{ 'DATA_CHANGE_PASSWORD' | translate }}</a\n                    >\n                    <a *ngIf=\"sidebarStatus\" (click)=\"deleteSession()\"\n                        >{{ 'DATA_LOGOUT' | translate}}</a\n                    >\n                </div>\n            </div>\n        </div>\n\n        <div *ngIf=\"module != 'bus'\">\n            <ul *ngIf=\"sidebarStatus\">\n                <li>\n                    <a (click)=\"deleteSession()\"\n                        >{{ 'DATA_LOGOUT' | translate}}</a\n                    >\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n\n<!--Change Password Dialog-->\n<p-dialog\n    header=\"{{ 'DATA_CHANGE_PASSWORD' | translate }}\"\n    [(visible)]=\"isShowChangePassword\"\n    (onBeforeHide)=\"onCloseChangePassword(f)\"\n    [draggable]=\"false\"\n    [resizable]=\"false\"\n    [modal]=\"true\"\n    [closable]=\"true\"\n    [responsive]=\"true\"\n    [appendTo]=\"body\"\n    width=\"500\"\n>\n    <form #f=\"ngForm\" (ngSubmit)=\"onSubmitChangePassword(f)\">\n        <div class=\"dialog-content\" style=\"text-align: center\">\n            <div class=\"form-group\">\n                <input\n                    id=\"opass\"\n                    [(ngModel)]=\"oldPassword\"\n                    name=\"old-password\"\n                    type=\"password\"\n                    placeholder=\"Old Password\"\n                    #oPass=\"ngModel\"\n                    required\n                />\n                <div\n                    *ngIf=\"oPass.errors && (oPass.dirty || oPass.touched)\"\n                    class=\"alert alert-danger\"\n                >\n                    <span\n                        class=\"alert alert-danger\"\n                        [hidden]=\"oPass.error?.required\"\n                    >\n                        {{ 'DATA_PASSWORD_REQUIRED' | translate }}\n                    </span>\n                </div>\n                <div\n                    *ngIf=\"isOPassWrong && oPassCheck == oldPassword\"\n                    class=\"alert alert-danger\"\n                >\n                    <span class=\"alert alert-danger\">\n                        {{ 'DATA_WRONG_OLD_PASSWORD' | translate }}\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <input\n                    [(ngModel)]=\"newPassword\"\n                    name=\"new-password\"\n                    type=\"password\"\n                    placeholder=\"New Password\"\n                    pattern=\"{{ cPass.value }}\"\n                    #nPass=\"ngModel\"\n                    required\n                />\n                <div\n                    *ngIf=\"oPass.value != '' && nPass.errors?.required && (nPass.dirty || nPass.touched)\"\n                    class=\"alert alert-danger\"\n                >\n                    <span> {{ 'DATA_PASSWORD_REQUIRED' | translate }} </span>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <input\n                    [(ngModel)]=\"confirmPassword\"\n                    name=\"confirm-password\"\n                    type=\"password\"\n                    placeholder=\"Re-type Password\"\n                    pattern=\"{{ nPass.value }}\"\n                    #cPass=\"ngModel\"\n                    required\n                />\n                <div\n                    *ngIf=\"nPass.value != '' && cPass.errors?.required && (cPass.dirty || cPass.touched)\"\n                    class=\"alert alert-danger\"\n                >\n                    <span> {{ 'DATA_PASSWORD_REQUIRED' | translate }} </span>\n                </div>\n                <div\n                    *ngIf=\"nPass.value != '' && cPass.errors?.pattern && cPass.touched\"\n                    class=\"alert alert-danger\"\n                >\n                    <span> {{ 'DATA_PASSWORD_MISMATCH' | translate }} </span>\n                </div>\n            </div>\n            <!-- <input   [(ngModel)]=\"confirmPassword\" name=\"confirm-password\" type=\"password\" placeholder=\"Re-type New Password\"/> -->\n        </div>\n        <div style=\"text-align: center\">\n            <br />\n            <button [disabled]=\"f.invalid\" type=\"submit\">\n                {{ 'DATA_BUTTON_CONFIRM' | translate }}\n            </button>\n        </div>\n    </form>\n</p-dialog>\n\n<p-growl [value]=\"msgs\"></p-growl>\n";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/helen-logo-1.fe25fba31d07bf0e867e6c43e1543fa2.png";

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports = ".alert-danger{text-align:left;margin:-12px 0px 12px 5px;font-style:normal;color:#f54c2f}.header.row{height:78px;border-bottom:1px solid #e1e4e9;position:fixed;left:0;top:0;width:100%;z-index:5;max-width:100%}.header.row h1{background:#fff;display:inline-block;text-align:center;margin-bottom:0;padding:0 1.3125rem;display:flex;align-items:center;justify-content:center}.header.row h1 img{width:46px;cursor:pointer}.header.row .header-info{background:#00707e;padding:0 2rem;overflow:hidden;width:calc(100% - 160px - 1.3125rem * 2)}.header.row .header-info .component-name{float:left}.header.row .header-info .component-name h3{font-size:0.875rem;color:#fff;line-height:78px;margin-bottom:0;display:inline-block}.header.row .header-info ul{float:right;margin:0;font-size:0.875rem;line-height:77px;list-style:none}.header.row .header-info ul li a{color:#fff}.header.row .header-info .dropdown{float:right;margin:0;font-size:0.875rem;line-height:80px;list-style:none;color:#fff;display:flex;cursor:pointer}.header.row .header-info .dropdown a{color:#fff}.header.row .header-info .dropdown i{line-height:3.2 !important}.header.row .header-info .dropdown .dropdown-content{position:absolute;background-color:#f9f9f9;min-width:160px;box-shadow:0px 8px 16px 0px rgba(0,0,0,0.2);z-index:1;margin-top:65px;right:30px}.header.row .header-info .dropdown .dropdown-content a{color:#414042;padding:10px 16px;text-decoration:none;display:block;line-height:2 !important}.header.row .header-info .dropdown .dropdown-content a:hover{background-color:#eee}\n"

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(70);
	var AdminService_1 = __webpack_require__(113);
	var SessionService_1 = __webpack_require__(123);
	var config_1 = __webpack_require__(114);
	var AdminHeaderAuthComponent = (function () {
	    // For logout navigate
	    function AdminHeaderAuthComponent(adminService, sessionService, router) {
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.router = router;
	    }
	    AdminHeaderAuthComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        this.hostName = window.location.hostname;
	        this.headerName = this.getHeaderName(this.module);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	        // Get Admin session
	        this.adminData = this.adminService.getAdminSessionData();
	    };
	    AdminHeaderAuthComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    AdminHeaderAuthComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	        this.sidebarStatus = this.getSidebarStatus();
	    };
	    AdminHeaderAuthComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	        });
	    };
	    AdminHeaderAuthComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL                    
	        if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.devEnv.services;
	        }
	        else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.testEnv.services;
	        }
	        else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	        }
	        else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	        }
	        else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "https://" + config_1.stagingEnv.services;
	        }
	        else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "https://" + config_1.procEnv.services;
	        }
	        else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.demoEnv.services;
	        }
	        else {
	            return window.location.href = "http://" + config_1.localEnv.services;
	        }
	    };
	    // Detect sidebar vibibility
	    AdminHeaderAuthComponent.prototype.getSidebarStatus = function () {
	        return !this.adminData ? false : true;
	    };
	    AdminHeaderAuthComponent.prototype.getHeaderName = function (moduleName) {
	        var headerName = "";
	        switch (this.module) {
	            case "camp":
	                headerName = "Camp Programmes Management";
	                break;
	            case "asa":
	                headerName = "After School Activities Management";
	                break;
	            case "bus":
	                headerName = "Bus Management";
	                break;
	            case "reen":
	                headerName = "Re-enrolment";
	                break;
	            case "conference":
	                headerName = "Conference Booking System";
	                break;
	            default:
	                break;
	        }
	        return headerName;
	    };
	    // Log our function
	    AdminHeaderAuthComponent.prototype.deleteSession = function () {
	        var _this = this;
	        // In case system login and booking for parent. Then, logout and login again with role parent to booking. We need to remove sessionStorage 
	        if (this.module === 'conference') {
	            window.sessionStorage.removeItem('info-parent-booking');
	            window.sessionStorage.removeItem('interview-description');
	        }
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.adminService.adminDataChanged(null);
	            // Redirect to desired URL
	            if (Object.values(config_1.devEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.testEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.procEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.auth + "/login";
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.auth + "/login";
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    return AdminHeaderAuthComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminHeaderAuthComponent.prototype, "module", void 0);
	AdminHeaderAuthComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-header-auth',
	        template: __webpack_require__(129),
	        styles: [__webpack_require__(130)]
	    }),
	    __metadata("design:paramtypes", [AdminService_1.AdminService,
	        SessionService_1.SessionService,
	        router_1.Router])
	], AdminHeaderAuthComponent);
	exports.AdminHeaderAuthComponent = AdminHeaderAuthComponent;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"app-main-menu\">\n\t<!-- Hamburger Menu -->\n\t<div class=\"hamburger-menu\">\n\t\t<a href=\"#\">\n\t\t\t<i class=\"material-icons\">menu</i>\n\t\t</a>\n\t</div>\n\t<div class=\"container\">\n\t\t<div class=\"top-bar\">\n\t\t\t<!--Top bar left-->\n\t\t\t<div class=\"top-bar-left\">\n\t\t\t\t<!-- Logo -->\n\t\t\t\t<div class=\"logo\">\n\t\t\t\t\t<a (click)=\"toHomePage()\"><img src=\"" + __webpack_require__(116) + "\"></a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!--End of Top bar left-->\n\n\t\t\t<!--Top bar right-->\n\t\t\t<div class=\"top-bar-right\">\n\t\t\t\t<!-- Menu Items -->\n\t\t\t\t<div class=\"main-right-menu\">\n\t\t\t\t\t<ul class=\"menu\" *ngIf=\"menuStatus\">\n\t\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t\t<li *ngFor=\"let menu of menuList;\">\n\t\t\t\t\t\t\t<div *ngIf=\"!userData\">\n\t\t\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<!-- Show user menu item if have user data from session -->\n\t\t\t\t\t\t<li *ngIf=\"userData\" class=\"user-profile-menu\" [menuHover]=\"userMenuClassVisible\">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<a>\n\t\t\t\t\t\t\t\t\t<span>Hi, {{userData.name.split('@')[0]}}</span>\n\t\t\t\t\t\t\t\t\t<i class=\"material-icons\">keyboard_arrow_down</i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<ul class=\"\">\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"toChangePassword()\">Change Password</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li *ngIf=\"!checkAccountIsVasParent()\">\n\t\t\t\t\t\t\t\t\t<a (click)=\"toProfile()\">Profile</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"deleteSession()\">Logout</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t\t<!--New sub menu for module-->\n\t\t\t\t<ul class=\"sub-menu\" *ngIf=\"userData\" >\n\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t<li *ngFor=\"let menu of subMenuList\">\n\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<!--End of sub menu-->\n\t\t\t</div>\n\t\t\t<!--End of top bar right-->\n\t\t</div>\n\t\t<!--End of top bar-->\n\t</div>\n</div>";

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = "#app-main-menu{background-color:#00707e;position:relative}#app-main-menu .hamburger-menu{display:none}#app-main-menu .top-bar{background:transparent;padding:0 0.5rem 0 0;height:116px}#app-main-menu .top-bar .top-bar-left{flex:0.2 0.5 0px;height:100%}#app-main-menu .top-bar .top-bar-left .logo{height:100%}#app-main-menu .top-bar .top-bar-right{padding-top:1rem}#app-main-menu .logo>a{display:inline-block}#app-main-menu .logo>a img{height:116px}#app-main-menu .sub-menu{float:right;background:transparent;font-size:0.9rem}#app-main-menu .sub-menu li{list-style:none;display:inline-block;text-transform:uppercase}#app-main-menu .sub-menu li a{display:block;color:#fff;padding:0.5rem;margin:0 0.3rem}#app-main-menu .sub-menu li a.active{border-bottom:solid 2px #ffae00}#app-main-menu .main-right-menu{float:right}#app-main-menu .main-right-menu .menu{background-color:#00707e}#app-main-menu .main-right-menu .menu>li>div>a{padding:0.5rem 1rem;border-radius:0.2rem;margin-left:1rem;min-width:6.25rem;border:1px solid #00707e;color:#fff;text-align:center}#app-main-menu .main-right-menu .menu>li>div>a:hover,#app-main-menu .main-right-menu .menu>li>div>a.active{background-color:#faa635;border:1px solid #faa635;color:#00707e;border:1px solid #00707e}#app-main-menu .main-right-menu .menu>li>div>a>i{margin:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu{position:relative}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a{margin-bottom:0.5rem;line-height:23px;display:inline-block;padding-top:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a span{display:inline-block}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a i{display:inline-block;position:relative;top:6px}#app-main-menu .main-right-menu .menu>li.user-profile-menu>ul{list-style:none;border-radius:0.2rem;position:absolute;z-index:2;right:0;width:130%;display:none}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul{display:block;box-shadow:0 8px 10px 1px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0,0,0,0.2)}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a{display:block;padding:0.4rem 1rem;border-radius:0.2rem}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a:hover{background-color:#faa635;color:#00707e}@media only screen and (max-width: 40em){#app-main-menu{height:auto;min-height:4rem}#app-main-menu .hamburger-menu{position:absolute;display:none;left:0;top:50%;transform:translateY(-50%);-ms-transform:translateY(-50%);-webkit-transform:translateY(-50%)}#app-main-menu .hamburger-menu>a{color:#fff;font-size:2rem}#app-main-menu .hamburger-menu>a>i{padding:1rem}#app-main-menu .logo{padding:0.4rem;margin:0 auto}#app-main-menu .logo>a{margin:0 auto;min-height:3rem}#app-main-menu .main-right-menu{display:none}#app-main-menu .top-bar-left{flex:none !important}}\n"

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuService_1 = __webpack_require__(99);
	var AdminService_1 = __webpack_require__(113);
	var SessionService_1 = __webpack_require__(123);
	var core_2 = __webpack_require__(38);
	var AdminSidebarComponent = (function () {
	    function AdminSidebarComponent(translate, menuService, adminService, sessionService) {
	        this.translate = translate;
	        this.menuService = menuService;
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.hideMenu = new core_1.EventEmitter();
	        this.isSmall = false;
	        this.isShowText = false;
	    }
	    AdminSidebarComponent.prototype.toggleSmallSidebard = function () {
	        this.isSmall = !this.isSmall;
	        this.hideMenu.emit(this.isShowText);
	    };
	    AdminSidebarComponent.prototype.animationDone = function (event) {
	        if (event.fromState == "inactive") {
	            this.isShowText = !this.isShowText;
	        }
	    };
	    AdminSidebarComponent.prototype.animationStart = function (event) {
	        if (event.fromState == "active") {
	            this.isShowText = !this.isShowText;
	        }
	    };
	    AdminSidebarComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        // Get Sidebar menu list
	        var sidebarName = this.getSidebarName(this.module);
	        this.sidebar = this.menuService.getMenuList(sidebarName);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	        if (sidebarName == "bus-admin-sidebar") {
	            this.sidebar.forEach(function (e) {
	                if (e.id == "bus-schedule")
	                    e.label = 'DATA_MENU_DAILY_TRANSPORT_LIST';
	                else if (e.id == "bus-student-management")
	                    e.label = 'DATA_MENU_STUDENT_REPORT';
	                else if (e.id == "bus-report")
	                    e.label = 'DATA_MENU_BUS_REPORT';
	                else if (e.id == "bus-settings")
	                    e.label = 'DATA_MENU_SETTINGS';
	            });
	        }
	    };
	    AdminSidebarComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    /**
	     * Action that fired when the session change event is catched.
	     * Update the adminData & the menuList.
	     */
	    AdminSidebarComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	    };
	    AdminSidebarComponent.prototype.getSidebarStatus = function () {
	        if (!this.adminData) {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    AdminSidebarComponent.prototype.getSidebarName = function (moduleName) {
	        var sidebarName = "";
	        switch (moduleName) {
	            case "camp":
	                sidebarName = "camp-admin-sidebar";
	                break;
	            case "asa":
	                sidebarName = "asa-admin-sidebar";
	                break;
	            case "bus":
	                sidebarName = "bus-admin-sidebar";
	                break;
	            case "holiday":
	                sidebarName = "holiday-admin-sidebar";
	                break;
	            case "reen":
	                sidebarName = "reen-admin-sidebar";
	                break;
	            default:
	                break;
	        }
	        return sidebarName;
	    };
	    // Check user role to show/hide option
	    AdminSidebarComponent.prototype.accessible = function (role) {
	        if (!role.length) {
	            return true;
	        }
	        return role.indexOf(this.adminData.role) !== -1 ? true : false;
	    };
	    AdminSidebarComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    return AdminSidebarComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminSidebarComponent.prototype, "module", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", core_1.EventEmitter)
	], AdminSidebarComponent.prototype, "hideMenu", void 0);
	AdminSidebarComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-sidebar',
	        template: __webpack_require__(132),
	        styles: [__webpack_require__(133)],
	        animations: [
	            core_1.trigger('toggleSidebar', [
	                core_1.state('inactive', core_1.style({
	                    width: '70px',
	                })),
	                core_1.state('active', core_1.style({
	                    width: '100%',
	                })),
	                core_1.transition('inactive => active', core_1.animate('200ms ease-in')),
	                core_1.transition('active => inactive', core_1.animate('200ms ease-out'))
	            ]),
	            core_1.trigger('toggleText', [
	                core_1.state('inactive', core_1.style({
	                    width: '0',
	                    height: '0',
	                    opacity: '0',
	                })),
	                core_1.state('active', core_1.style({
	                    width: '*',
	                    height: '*',
	                    opacity: '1',
	                })),
	                core_1.transition('inactive => active', core_1.animate('200ms ease-in')),
	                core_1.transition('active => inactive', core_1.animate('200ms ease-out'))
	            ])
	        ]
	    }),
	    __metadata("design:paramtypes", [core_2.TranslateService,
	        MenuService_1.MenuService,
	        AdminService_1.AdminService,
	        SessionService_1.SessionService])
	], AdminSidebarComponent);
	exports.AdminSidebarComponent = AdminSidebarComponent;


/***/ }),
/* 132 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sidebar\" *ngIf=\"sidebarStatus\" [@toggleSidebar]=\"isSmall ?  'inactive' : 'active'\" (@toggleSidebar.start)=\"animationStart($event)\" (@toggleSidebar.done)=\"animationDone($event)\">\n    <ul>\n        <li *ngFor=\"let item of sidebar\" [hidden]=\"!accessible(item.role)\">\n            <a routerLink=\"{{item.url}}\" routerLinkActive=\"active\">\n                <span [@toggleText]=\"isShowText ?  'inactive' : 'active'\" style=\"overflow: hidden;\">{{ item.label | translate }}</span>\n                <i class=\"material-icons\">{{item.icon}}</i>\n            </a>\n        </li>\n    </ul>\n    <div class=\"button-hide-menu\"  (click)=\"toggleSmallSidebard()\">\n        <i class=\"material-icons\" *ngIf=\"!isSmall\">chevron_left</i>\n        <i class=\"material-icons\" *ngIf=\"isSmall\">chevron_right</i>\n    </div>\n</div>";

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = ".sidebar{box-shadow:0 4px 4px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.2),0 1px 5px 0 rgba(0,0,0,0.12);position:absolute;background:#fff;height:100%;width:100%;border-right:1px solid #e1e4e9;z-index:1}.sidebar ul{background-color:#fff;z-index:10;position:relative;list-style:none;margin-left:0}.sidebar ul li{font-size:0.875rem;font-weight:600}.sidebar ul li a{color:#414042;display:block;overflow:hidden;padding:1.375rem}.sidebar ul li a span{display:inline-block;vertical-align:middle}.sidebar ul li a i{float:right}.sidebar ul li .active{background:#e6e6e6}.button-hide-menu{position:absolute;right:-20px;width:24px;height:40px;top:20px;line-height:40px;cursor:pointer;box-shadow:2px 1px 1px 0px rgba(0,0,0,0.14);background:#00707e;color:#fff}.button-hide-menu i{line-height:40px}\n"

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(123));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	__webpack_require__(136);
	__webpack_require__(139);
	__webpack_require__(147);
	var ClickOutsideDirective = (function () {
	    function ClickOutsideDirective(_elRef) {
	        this._elRef = _elRef;
	        this.listening = false;
	        this.clickOutside = new core_1.EventEmitter();
	    }
	    ClickOutsideDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        this.globalClick = Observable_1.Observable
	            .fromEvent(document, 'click')
	            .delay(1)
	            .do(function () {
	            _this.listening = true;
	        }).subscribe(function (event) {
	            _this.onGlobalClick(event);
	        });
	    };
	    ClickOutsideDirective.prototype.ngOnDestroy = function () {
	        this.globalClick.unsubscribe();
	    };
	    ClickOutsideDirective.prototype.onGlobalClick = function (event) {
	        if (event instanceof MouseEvent && this.listening === true) {
	            if (this.isDescendant(this._elRef.nativeElement, event.target) === true) {
	                this.clickOutside.emit({
	                    target: (event.target || null),
	                    value: false
	                });
	            }
	            else {
	                this.clickOutside.emit({
	                    target: (event.target || null),
	                    value: true
	                });
	            }
	        }
	    };
	    ClickOutsideDirective.prototype.isDescendant = function (parent, child) {
	        var node = child;
	        while (node !== null) {
	            if (node === parent) {
	                return true;
	            }
	            else {
	                node = node.parentNode;
	            }
	        }
	        return false;
	    };
	    return ClickOutsideDirective;
	}());
	__decorate([
	    core_1.Output('clickOutside'),
	    __metadata("design:type", core_1.EventEmitter)
	], ClickOutsideDirective.prototype, "clickOutside", void 0);
	ClickOutsideDirective = __decorate([
	    core_1.Directive({
	        selector: '[click-outside]'
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], ClickOutsideDirective);
	exports.ClickOutsideDirective = ClickOutsideDirective;


/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(221));
	__export(__webpack_require__(113));
	__export(__webpack_require__(123));
	__export(__webpack_require__(228));
	__export(__webpack_require__(223));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var shared_1 = __webpack_require__(24);
	var LoginComponent_1 = __webpack_require__(222);
	var LogoutComponent_1 = __webpack_require__(226);
	var AdminRouting_1 = __webpack_require__(227);
	var AdminService_1 = __webpack_require__(113);
	var SessionService_1 = __webpack_require__(123);
	var AdminModule = (function () {
	    function AdminModule() {
	    }
	    return AdminModule;
	}());
	AdminModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            shared_1.SharedModule,
	            AdminRouting_1.adminRouting,
	        ],
	        declarations: [
	            LoginComponent_1.LoginComponent,
	            LogoutComponent_1.LogoutComponent
	        ],
	        providers: [
	            AdminService_1.AdminService,
	            SessionService_1.SessionService,
	        ],
	        exports: [
	            LogoutComponent_1.LogoutComponent
	        ]
	    })
	], AdminModule);
	exports.AdminModule = AdminModule;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(70);
	// Services
	var SessionService_1 = __webpack_require__(123);
	var AdminService_1 = __webpack_require__(113);
	var AdminCredential_1 = __webpack_require__(223);
	var LoginComponent = (function () {
	    function LoginComponent(sessionService, adminService, router) {
	        this.sessionService = sessionService;
	        this.adminService = adminService;
	        this.router = router;
	        this.formSubmitted = false;
	        this.adminCredential = new AdminCredential_1.AdminCredential('', '', '');
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        this.deleteSession();
	        this.redirectUrl = '/navigate';
	        this.hostName = window.location.hostname;
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	    };
	    ;
	    LoginComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post admin login data to create session
	        this.postSession(this.adminCredential);
	    };
	    LoginComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            // Set admin session data
	            _this.adminService.setAdminSessionData(admin);
	            // Fire admin session data changed event
	            _this.adminService.adminDataChanged(admin);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update admin Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - admin credential input
	     * @return none
	     */
	    LoginComponent.prototype.postSession = function (adminCredential) {
	        var _this = this;
	        this.sessionService.postAdminSession(adminCredential)
	            .subscribe(function (admin) {
	            _this.adminService.setAdminSessionData(admin);
	            _this.adminService.adminDataChanged(admin);
	            // Redirect to nagigate center
	            _this.redirect('/navigate');
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid user name or password.";
	            _this.messageType = "alert";
	        });
	    };
	    // Redirect to desired url
	    LoginComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    LoginComponent.prototype.deleteSession = function () {
	        var _this = this;
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            _this.adminService.clearInterSession();
	            _this.adminService.adminDataChanged(null);
	        });
	    };
	    return LoginComponent;
	}());
	LoginComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-login',
	        template: __webpack_require__(224),
	        styles: [__webpack_require__(225)]
	    }),
	    __metadata("design:paramtypes", [SessionService_1.SessionService,
	        AdminService_1.AdminService,
	        router_1.Router])
	], LoginComponent);
	exports.LoginComponent = LoginComponent;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AdminCredential = (function () {
	    function AdminCredential(role, username, password) {
	        this.role = role;
	        this.username = username;
	        this.password = password;
	    }
	    return AdminCredential;
	}());
	exports.AdminCredential = AdminCredential;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1 style=\"color: #fff\">WELCOME TO NAS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\">\n            <!-- Form Title -->\n            <h3 class=\"text-center\">Login to your account</h3>\n            <!-- Alert Box -->\n            <div class=\"row\">\n                <div class=\"medium-12 columns\">\n                    <alert-box\n                        [message]=\"message\"\n                        [type]=\"messageType\"\n                    ></alert-box>\n                </div>\n            </div>\n\n            <!-- User name Input Field -->\n            <div class=\"row\">\n                <div class=\"medium-12 columns\">\n                    <label for=\"username\">User name</label>\n                    <input\n                        type=\"text\"\n                        placeholder=\"Type your user name\"\n                        id=\"username\"\n                        [(ngModel)]=\"adminCredential.username\"\n                        name=\"username\"\n                        #username=\"ngModel\"\n                        required\n                    />\n                </div>\n                <div\n                    [hidden]=\"username.valid || username.pristine\"\n                    class=\"help-text text-alert\"\n                >\n                    User name is required.\n                </div>\n            </div>\n            <!-- Password Input Field -->\n            <div class=\"row\">\n                <div class=\"medium-12 columns\">\n                    <label for=\"password\">Password</label>\n                    <input\n                        type=\"password\"\n                        placeholder=\"Type your password\"\n                        id=\"password\"\n                        [(ngModel)]=\"adminCredential.password\"\n                        name=\"password\"\n                        #password=\"ngModel\"\n                        required\n                    />\n                </div>\n            </div>\n            <!-- Submit Button -->\n            <div class=\"row\">\n                <div class=\"medium-12 columns\">\n                    <button type=\"submit\" name=\"submit\">Login</button>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n";

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	module.exports = ".eca-background{background-size:100% 100%}#user-login-component{height:calc(100% - 80px);padding:1rem}#user-login-component .component-title{margin:3rem 7rem;width:31.25%;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem 7rem;width:31.25%}#user-login-component .component-content form div.remember-block{position:relative;font-size:0.8rem;margin-bottom:0.5rem}#user-login-component .component-content form div.remember-block input[type=\"checkbox\"]{position:absolute;height:1.1rem;width:1.1rem;top:0.5rem;cursor:pointer}#user-login-component .component-content form div.remember-block label{margin-left:1.5rem}#user-login-component .component-content form .register-link{font-size:0.65rem;font-weight:500;text-align:center}#user-login-component .component-content form .forgot-password{display:block;font-size:0.8rem}#user-login-component .component-content form button:not(.close-button){width:100%}#user-login-component .component-content form button.close-button{line-height:1.2}@media (min-width: 1025px){#user-login-component .component-title{max-width:450px}#user-login-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-login-component .component-title{width:50%;max-width:450px}#user-login-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-login-component{padding:0}#user-login-component .component-title{display:none}#user-login-component .component-content{margin:0;width:100%}#user-login-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(70);
	// Services
	var SessionService_1 = __webpack_require__(123);
	var AdminService_1 = __webpack_require__(113);
	var config_1 = __webpack_require__(114);
	var LogoutComponent = (function () {
	    // For logout navigate
	    function LogoutComponent(router, sessionService, adminService) {
	        this.router = router;
	        this.sessionService = sessionService;
	        this.adminService = adminService;
	    }
	    LogoutComponent.prototype.ngOnInit = function () {
	        // Delete session from system
	        this.hostName = window.location.hostname;
	        this.deleteSession();
	        this.adminData = this.adminService.getAdminSessionData();
	    };
	    /**
	     * Delete user session data.
	     */
	    LogoutComponent.prototype.deleteSession = function () {
	        var _this = this;
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            // Fire user session data changed event
	            _this.adminService.adminDataChanged(null);
	            // Redirect to desired URL
	            if (Object.values(config_1.devEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.services;
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiStagingEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiStagingEnv.services;
	            }
	            else if (Object.values(config_1.ishcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.ishcmcEnv.services;
	            }
	            else if (Object.values(config_1.aavnIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.aavnIshcmcEnv.services;
	            }
	            else if (Object.values(config_1.primaryIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.primaryIshcmcEnv.services;
	            }
	            else if (Object.values(config_1.secondaryIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.secondaryIshcmcEnv.services;
	            }
	            else if (Object.values(config_1.isspEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.isspEnv.services;
	            }
	            else if (Object.values(config_1.demoHelenEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoHelenEnv.services;
	            }
	            else if (Object.values(config_1.testEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.services;
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.stagingEnv.services;
	            }
	            else if (Object.values(config_1.procEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.procEnv.services;
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.services;
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    // Redirect to desired url
	    LogoutComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return LogoutComponent;
	}());
	LogoutComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-logout',
	        template: '',
	        styles: []
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        SessionService_1.SessionService,
	        AdminService_1.AdminService])
	], LogoutComponent);
	exports.LogoutComponent = LogoutComponent;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(70);
	var LoginComponent_1 = __webpack_require__(222);
	var LogoutComponent_1 = __webpack_require__(226);
	var adminRoutes = [
	    {
	        path: 'login',
	        component: LoginComponent_1.LoginComponent
	    },
	    {
	        path: 'logout',
	        component: LogoutComponent_1.LogoutComponent
	    }
	];
	exports.adminRouting = router_1.RouterModule.forChild(adminRoutes);


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Admin = (function () {
	    function Admin() {
	    }
	    return Admin;
	}());
	exports.Admin = Admin;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(70);
	var AdminService_1 = __webpack_require__(113);
	var LocalNetworkService_1 = __webpack_require__(102);
	__webpack_require__(230);
	var AppComponent = (function () {
	    function AppComponent(router, adminService, localNetworkService) {
	        this.router = router;
	        this.adminService = adminService;
	        this.localNetworkService = localNetworkService;
	        this.redirectUrl = '/navigate';
	        // Detect show/hide sidebar
	        this.toggleSidebar = false;
	        this.module = 'auth';
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        // Get hostname
	        this.hostName = window.location.hostname;
	        // this.getLocal();
	        // Detect route to show sidebar
	        this.toggleSidebar = this.router.url == '/navigate' ? false : true;
	    };
	    // Detect local or public network
	    AppComponent.prototype.getLocal = function () {
	        var _this = this;
	        this.localNetworkService.getLocalNetWork()
	            .subscribe(function (result) {
	            _this.adminData = _this.adminService.getAdminSessionData();
	            _this.redirect(_this.redirectUrl);
	        }, function (err) {
	            if (_this.adminData) {
	                _this.redirect(_this.redirectUrl);
	            }
	        });
	    };
	    // Redirect function
	    AppComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return AppComponent;
	}());
	AppComponent = __decorate([
	    core_1.Component({
	        selector: 'my-app',
	        template: __webpack_require__(243),
	        styles: [__webpack_require__(244)]
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        AdminService_1.AdminService,
	        LocalNetworkService_1.LocalNetworkService])
	], AppComponent);
	exports.AppComponent = AppComponent;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports) {

	module.exports = "<!-- Application Top Menu -->\n<!-- <top-menu></top-menu> -->\n<!-- Application Main Menu -->\n<admin-header-auth [module]=\"module\"></admin-header-auth>\n<!-- Application Header -->\n<!-- <admin-header [module]=\"module\"></admin-header> -->\n<!-- Application Sidebar -->\n<div class=\"body-auth\">\n    <admin-sidebar [module]=\"module\" *ngIf=\"!toggleSidebar\"></admin-sidebar>\n    <!-- Application Content -->\n    <router-outlet></router-outlet>\n</div>\n<!-- Application Footer -->\n<footer></footer>";

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports = ".body-auth{background:#fff;max-width:100%}.body-auth:before{content:' ';display:table}\n"

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(70);
	var NavigateComponent_1 = __webpack_require__(246);
	var appRoutes = [
	    { path: '',
	        redirectTo: 'login',
	        pathMatch: 'full'
	    },
	    {
	        path: 'navigate',
	        component: NavigateComponent_1.NavigateComponent
	    }
	];
	exports.appRoutingProviders = [];
	exports.routing = router_1.RouterModule.forRoot(appRoutes);


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(70);
	var AdminService_1 = __webpack_require__(113);
	var SessionService_1 = __webpack_require__(123);
	var UserService_1 = __webpack_require__(110);
	var config_1 = __webpack_require__(114);
	var NavigateComponent = (function () {
	    function NavigateComponent(router, userService, sessionService, adminService) {
	        this.router = router;
	        this.userService = userService;
	        this.sessionService = sessionService;
	        this.adminService = adminService;
	        this.sidebarStatus = false;
	    }
	    NavigateComponent.prototype.ngOnInit = function () {
	        this.getSession();
	        this.sidebarStatus = false;
	        this.hostName = window.location.hostname;
	        console.log(this.hostName);
	    };
	    NavigateComponent.prototype.toAsa = function () {
	        switch (this.hostName) {
	            case config_1.procEnv.auth:
	                window.location.href = "https://" + config_1.procEnv.asa + "/asa/admin/";
	                break;
	            case config_1.devEnv.auth:
	                window.location.href = "http://" + config_1.devEnv.asa + "/asa/admin/";
	                break;
	            case config_1.testEnv.auth:
	                window.location.href = "http://" + config_1.testEnv.asa + "/asa/admin/";
	                break;
	            case config_1.bisHanoiEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiEnv.asa + "/asa/admin/";
	                break;
	            case config_1.bisHanoiDevEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.asa + "/asa/admin/";
	                break;
	            case config_1.bisHanoiStagingEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiStagingEnv.asa + "/asa/admin/";
	                break;
	            case config_1.ishcmcEnv.auth:
	                window.location.href = "http://" + config_1.ishcmcEnv.asa + "/asa/admin/";
	                break;
	            case config_1.aavnIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.aavnIshcmcEnv.asa + "/asa/admin/";
	                break;
	            case config_1.primaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.primaryIshcmcEnv.asa + "/asa/admin/";
	                break;
	            case config_1.secondaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.secondaryIshcmcEnv.asa + "/asa/admin/";
	                break;
	            case config_1.isspEnv.auth:
	                window.location.href = "http://" + config_1.isspEnv.asa + "/asa/admin/";
	                break;
	            case config_1.demoHelenEnv.auth:
	                window.location.href = "http://" + config_1.demoHelenEnv.asa + "/asa/admin/";
	                break;
	            case config_1.stagingEnv.auth:
	                window.location.href = "https://" + config_1.stagingEnv.asa + "/asa/admin/";
	                break;
	            case config_1.demoEnv.auth:
	                window.location.href = "http://" + config_1.demoEnv.asa + "/asa/admin/";
	                break;
	            default:
	                window.location.href = "http://" + config_1.localEnv.asa + "/asa/admin/";
	                break;
	        }
	    };
	    NavigateComponent.prototype.toHoliday = function () {
	        switch (this.hostName) {
	            case config_1.procEnv.auth:
	                window.location.href = "https://" + config_1.procEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.devEnv.auth:
	                window.location.href = "http://" + config_1.devEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.testEnv.auth:
	                window.location.href = "http://" + config_1.testEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.bisHanoiEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.bisHanoiDevEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.bisHanoiStagingEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiStagingEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.ishcmcEnv.auth:
	                window.location.href = "http://" + config_1.ishcmcEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.aavnIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.aavnIshcmcEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.primaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.primaryIshcmcEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.secondaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.secondaryIshcmcEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.isspEnv.auth:
	                window.location.href = "http://" + config_1.isspEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.demoHelenEnv.auth:
	                window.location.href = "http://" + config_1.demoHelenEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.stagingEnv.auth:
	                window.location.href = "https://" + config_1.stagingEnv.holiday + "/holiday/admin/";
	                break;
	            case config_1.demoEnv.auth:
	                window.location.href = "http://" + config_1.demoEnv.holiday + "/holiday/admin/";
	                break;
	            default:
	                window.location.href = "http://" + config_1.localEnv.holiday + "/holiday/admin/";
	                break;
	        }
	    };
	    NavigateComponent.prototype.toCamp = function () {
	        switch (this.hostName) {
	            case config_1.procEnv.auth:
	                window.location.href = "https://" + config_1.procEnv.camp + "/camp/admin/";
	                break;
	            case config_1.devEnv.auth:
	                window.location.href = "http://" + config_1.devEnv.camp + "/camp/admin/";
	                break;
	            case config_1.testEnv.auth:
	                window.location.href = "http://" + config_1.testEnv.camp + "/camp/admin/";
	                break;
	            case config_1.bisHanoiEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiEnv.camp + "/camp/admin/";
	                break;
	            case config_1.bisHanoiDevEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.camp + "/camp/admin/";
	                break;
	            case config_1.bisHanoiStagingEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiStagingEnv.camp + "/camp/admin/";
	                break;
	            case config_1.ishcmcEnv.auth:
	                window.location.href = "http://" + config_1.ishcmcEnv.camp + "/camp/admin/";
	                break;
	            case config_1.aavnIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.aavnIshcmcEnv.camp + "/camp/admin/";
	                break;
	            case config_1.primaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.primaryIshcmcEnv.camp + "/camp/admin/";
	                break;
	            case config_1.secondaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.secondaryIshcmcEnv.camp + "/camp/admin/";
	                break;
	            case config_1.isspEnv.auth:
	                window.location.href = "http://" + config_1.isspEnv.camp + "/camp/admin/";
	                break;
	            case config_1.demoHelenEnv.auth:
	                window.location.href = "http://" + config_1.demoHelenEnv.camp + "/camp/admin/";
	                break;
	            case config_1.stagingEnv.auth:
	                window.location.href = "https://" + config_1.stagingEnv.camp + "/camp/admin/";
	                break;
	            case config_1.demoEnv.auth:
	                window.location.href = "http://" + config_1.demoEnv.camp + "/camp/admin/";
	                break;
	            default:
	                window.location.href = "http://" + config_1.localEnv.camp + "/camp/admin/";
	                break;
	        }
	    };
	    NavigateComponent.prototype.toBus = function () {
	        switch (this.hostName) {
	            case config_1.procEnv.auth:
	                window.location.href = "https://" + config_1.procEnv.bus + "/bus/admin/";
	                break;
	            case config_1.devEnv.auth:
	                window.location.href = "http://" + config_1.devEnv.bus + "/bus/admin/";
	                break;
	            case config_1.testEnv.auth:
	                window.location.href = "http://" + config_1.testEnv.bus + "/bus/admin/";
	                break;
	            case config_1.bisHanoiEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiEnv.bus + "/bus/admin/";
	                break;
	            case config_1.bisHanoiDevEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.bus + "/bus/admin/";
	                break;
	            case config_1.bisHanoiStagingEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiStagingEnv.bus + "/bus/admin/";
	                break;
	            case config_1.ishcmcEnv.auth:
	                window.location.href = "http://" + config_1.ishcmcEnv.bus + "/bus/admin/";
	                break;
	            case config_1.aavnIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.aavnIshcmcEnv.bus + "/bus/admin/";
	                break;
	            case config_1.primaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.primaryIshcmcEnv.bus + "/bus/admin/";
	                break;
	            case config_1.secondaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.secondaryIshcmcEnv.bus + "/bus/admin/";
	                break;
	            case config_1.isspEnv.auth:
	                window.location.href = "http://" + config_1.isspEnv.bus + "/bus/admin/";
	                break;
	            case config_1.demoHelenEnv.auth:
	                window.location.href = "http://" + config_1.demoHelenEnv.bus + "/bus/admin/";
	                break;
	            case config_1.stagingEnv.auth:
	                window.location.href = "https://" + config_1.stagingEnv.bus + "/bus/admin/";
	                break;
	            case config_1.demoEnv.auth:
	                window.location.href = "http://" + config_1.demoEnv.bus + "/bus/admin/";
	                break;
	            default:
	                window.location.href = "http://" + config_1.localEnv.bus + "/bus/admin/";
	                break;
	        }
	    };
	    NavigateComponent.prototype.toConferenceBooking = function () {
	        switch (this.hostName) {
	            case config_1.procEnv.conference:
	                window.location.href = "https://" + config_1.procEnv.conference + "/conference/admin/";
	                break;
	            case config_1.devEnv.auth:
	                window.location.href = "http://" + config_1.devEnv.conference + "/conference/admin/";
	                break;
	            case config_1.testEnv.auth:
	                window.location.href = "http://" + config_1.testEnv.conference + "/conference/admin/";
	                break;
	            case config_1.bisHanoiEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiEnv.conference + "/conference/admin/";
	                break;
	            case config_1.bisHanoiDevEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.conference + "/conference/admin/";
	                break;
	            case config_1.bisHanoiStagingEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiStagingEnv.conference + "/conference/admin/";
	                break;
	            case config_1.ishcmcEnv.auth:
	                window.location.href = "http://" + config_1.ishcmcEnv.conference + "/conference/admin/";
	                break;
	            case config_1.aavnIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.aavnIshcmcEnv.conference + "/conference/admin/";
	                break;
	            case config_1.primaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.primaryIshcmcEnv.conference + "/conference/admin/";
	                break;
	            case config_1.secondaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.secondaryIshcmcEnv.conference + "/conference/admin/";
	                break;
	            case config_1.isspEnv.auth:
	                window.location.href = "http://" + config_1.isspEnv.conference + "/conference/admin/";
	                break;
	            case config_1.demoHelenEnv.auth:
	                window.location.href = "http://" + config_1.demoHelenEnv.conference + "/conference/admin/";
	                break;
	            case config_1.stagingEnv.auth:
	                window.location.href = "https://" + config_1.stagingEnv.conference + "/conference/admin/";
	                break;
	            case config_1.demoEnv.auth:
	                window.location.href = "http://" + config_1.demoEnv.conference + "/conference/admin/";
	                break;
	            default:
	                window.location.href = "http://" + config_1.localEnv.conference + "/conference/admin/";
	                break;
	        }
	    };
	    NavigateComponent.prototype.toAccessControl = function () {
	        switch (this.hostName) {
	            case 'auth.aisvietnam.com':
	                window.location.href = 'https://acs.aisvietnam.com/';
	                break;
	            case config_1.devEnv.auth:
	                window.location.href = 'http://acs.vas.dev.nascorp.vn/';
	                break;
	            case 'auth.eca.test.nascorp.vn':
	                window.location.href = 'http://acs.eca.test.nascorp.vn/';
	                break;
	            case 'uat-auth.aisvietnam.com':
	                window.location.href = 'https://uat-acs.aisvietnam.com/';
	                break;
	            default:
	                window.location.href = 'http://acs.local.vas.dev.nascorp.vn/';
	                break;
	        }
	    };
	    NavigateComponent.prototype.toAnnouncementsManagement = function () {
	        switch (this.hostName) {
	            case config_1.devEnv.auth:
	                window.location.href = "http://" + config_1.devEnv.event + "/admin";
	                break;
	            case config_1.testEnv.auth:
	                window.location.href = "http://" + config_1.testEnv.event + "/admin";
	                break;
	            case config_1.bisHanoiEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiEnv.event + "/admin";
	                break;
	            case config_1.bisHanoiDevEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.event + "/admin";
	                break;
	            case config_1.bisHanoiStagingEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiStagingEnv.event + "/admin";
	                break;
	            case config_1.ishcmcEnv.auth:
	                window.location.href = "http://" + config_1.ishcmcEnv.event + "/admin";
	                break;
	            case config_1.aavnIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.aavnIshcmcEnv.event + "/admin";
	                break;
	            case config_1.primaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.primaryIshcmcEnv.event + "/admin";
	                break;
	            case config_1.secondaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.secondaryIshcmcEnv.event + "/admin";
	                break;
	            case config_1.isspEnv.auth:
	                window.location.href = "http://" + config_1.isspEnv.event + "/admin";
	                break;
	            case config_1.demoHelenEnv.auth:
	                window.location.href = "http://" + config_1.demoHelenEnv.event + "/admin";
	                break;
	            case config_1.procEnv.auth:
	                window.location.href = "https://" + config_1.procEnv.event + "/admin";
	                break;
	            case config_1.stagingEnv.auth:
	                window.location.href = "https://" + config_1.stagingEnv.event + "/admin";
	                break;
	            case config_1.demoEnv.auth:
	                window.location.href = "http://" + config_1.demoEnv.event + "/admin";
	                break;
	            default:
	                window.location.href = "https://" + config_1.localEnv.event + "/admin";
	                break;
	        }
	    };
	    NavigateComponent.prototype.toChatHistory = function () {
	        switch (this.hostName) {
	            case config_1.devEnv.auth:
	                window.location.href = "http://" + config_1.devEnv.history;
	                break;
	            case config_1.testEnv.auth:
	                window.location.href = "http://" + config_1.testEnv.history;
	                break;
	            case config_1.bisHanoiEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiEnv.history;
	                break;
	            case config_1.bisHanoiDevEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.history;
	                break;
	            case config_1.bisHanoiStagingEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiStagingEnv.history;
	                break;
	            case config_1.ishcmcEnv.auth:
	                window.location.href = "http://" + config_1.ishcmcEnv.history;
	                break;
	            case config_1.aavnIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.aavnIshcmcEnv.history;
	                break;
	            case config_1.primaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.primaryIshcmcEnv.history;
	                break;
	            case config_1.secondaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.secondaryIshcmcEnv.history;
	                break;
	            case config_1.isspEnv.auth:
	                window.location.href = "http://" + config_1.isspEnv.history;
	                break;
	            case config_1.demoHelenEnv.auth:
	                window.location.href = "http://" + config_1.demoHelenEnv.history;
	                break;
	            case config_1.procEnv.auth:
	                window.location.href = "https://" + config_1.procEnv.history;
	                break;
	            case config_1.stagingEnv.auth:
	                window.location.href = "https://" + config_1.stagingEnv.history;
	                break;
	            case config_1.demoEnv.auth:
	                window.location.href = "http://" + config_1.demoEnv.history;
	                break;
	            default:
	                window.location.href = "https://" + config_1.localEnv.history;
	                break;
	        }
	    };
	    NavigateComponent.prototype.toParentMeeting = function () {
	        switch (this.hostName) {
	            case config_1.devEnv.auth:
	                window.location.href = "http://" + config_1.devEnv.meeting;
	                break;
	            case config_1.testEnv.auth:
	                window.location.href = "http://" + config_1.testEnv.meeting;
	                break;
	            case config_1.bisHanoiEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiEnv.meeting;
	                break;
	            case config_1.bisHanoiDevEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.meeting;
	                break;
	            case config_1.bisHanoiStagingEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiStagingEnv.meeting;
	                break;
	            case config_1.ishcmcEnv.auth:
	                window.location.href = "http://" + config_1.ishcmcEnv.meeting;
	                break;
	            case config_1.aavnIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.aavnIshcmcEnv.meeting;
	                break;
	            case config_1.primaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.primaryIshcmcEnv.meeting;
	                break;
	            case config_1.secondaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.secondaryIshcmcEnv.meeting;
	                break;
	            case config_1.isspEnv.auth:
	                window.location.href = "http://" + config_1.isspEnv.meeting;
	                break;
	            case config_1.demoHelenEnv.auth:
	                window.location.href = "http://" + config_1.demoHelenEnv.meeting;
	                break;
	            case config_1.procEnv.auth:
	                window.location.href = "https://" + config_1.procEnv.meeting;
	                break;
	            case config_1.stagingEnv.auth:
	                window.location.href = "https://" + config_1.stagingEnv.meeting;
	                break;
	            case config_1.demoEnv.auth:
	                window.location.href = "http://" + config_1.demoEnv.meeting;
	                break;
	            default:
	                window.location.href = "https://" + config_1.localEnv.meeting;
	                break;
	        }
	    };
	    NavigateComponent.prototype.toEnrolment = function () {
	        switch (this.hostName) {
	            case config_1.devEnv.auth:
	                window.location.href = "http://" + config_1.devEnv.enrolment + "/admin";
	                break;
	            case config_1.testEnv.auth:
	                window.location.href = "http://" + config_1.testEnv.enrolment + "/admin";
	                break;
	            case config_1.bisHanoiEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiEnv.enrolment + "/admin";
	                break;
	            case config_1.bisHanoiDevEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.enrolment + "/admin";
	                break;
	            case config_1.bisHanoiStagingEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiStagingEnv.enrolment + "/admin";
	                break;
	            case config_1.ishcmcEnv.auth:
	                window.location.href = "http://" + config_1.ishcmcEnv.enrolment + "/admin";
	                break;
	            case config_1.aavnIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.aavnIshcmcEnv.enrolment + "/admin";
	                break;
	            case config_1.primaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.primaryIshcmcEnv.enrolment + "/admin";
	                break;
	            case config_1.secondaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.secondaryIshcmcEnv.enrolment + "/admin";
	                break;
	            case config_1.isspEnv.auth:
	                window.location.href = "http://" + config_1.isspEnv.enrolment + "/admin";
	                break;
	            case config_1.demoHelenEnv.auth:
	                window.location.href = "http://" + config_1.demoHelenEnv.enrolment + "/admin";
	                break;
	            case config_1.procEnv.auth:
	                window.location.href = "https://" + config_1.procEnv.enrolment + "/admin";
	                break;
	            case config_1.stagingEnv.auth:
	                window.location.href = "https://" + config_1.stagingEnv.enrolment + "/admin";
	                break;
	            case config_1.demoEnv.auth:
	                window.location.href = "http://" + config_1.demoEnv.enrolment + "/admin";
	                break;
	            default:
	                window.location.href = "https://" + config_1.localEnv.enrolment + "/admin";
	                break;
	        }
	    };
	    NavigateComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession().subscribe(function (user) {
	            _this.userData = user;
	            // this.adminData = this.adminService.getAdminSessionData();
	            // this.role = this.adminData.role
	            _this.role = _this.userData.role;
	            console.log(_this.role);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = '';
	            _this.messageType = 'alert';
	        });
	    };
	    NavigateComponent.prototype.toMyAis = function () {
	        this.myAisToken();
	        // window.open('http://myais.vn', '_blank')
	    };
	    // Convert string SHA1
	    NavigateComponent.prototype.SHA1 = function (msg) {
	        function rotate_left(n, s) {
	            var t4 = (n << s) | (n >>> (32 - s));
	            return t4;
	        }
	        function lsb_hex(val) {
	            var str = '';
	            var i;
	            var vh;
	            var vl;
	            for (i = 0; i <= 6; i += 2) {
	                vh = (val >>> (i * 4 + 4)) & 0x0f;
	                vl = (val >>> (i * 4)) & 0x0f;
	                str += vh.toString(16) + vl.toString(16);
	            }
	            return str;
	        }
	        function cvt_hex(val) {
	            var str = '';
	            var i;
	            var v;
	            for (i = 7; i >= 0; i--) {
	                v = (val >>> (i * 4)) & 0x0f;
	                str += v.toString(16);
	            }
	            return str;
	        }
	        function Utf8Encode(string) {
	            string = string.replace(/\r\n/g, '\n');
	            var utftext = '';
	            for (var n = 0; n < string.length; n++) {
	                var c = string.charCodeAt(n);
	                if (c < 128) {
	                    utftext += String.fromCharCode(c);
	                }
	                else if (c > 127 && c < 2048) {
	                    utftext += String.fromCharCode((c >> 6) | 192);
	                    utftext += String.fromCharCode((c & 63) | 128);
	                }
	                else {
	                    utftext += String.fromCharCode((c >> 12) | 224);
	                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
	                    utftext += String.fromCharCode((c & 63) | 128);
	                }
	            }
	            return utftext;
	        }
	        var blockstart;
	        var i, j;
	        var W = new Array(80);
	        var H0 = 0x67452301;
	        var H1 = 0xefcdab89;
	        var H2 = 0x98badcfe;
	        var H3 = 0x10325476;
	        var H4 = 0xc3d2e1f0;
	        var A, B, C, D, E;
	        var temp;
	        msg = Utf8Encode(msg);
	        var msg_len = msg.length;
	        var word_array = new Array();
	        for (i = 0; i < msg_len - 3; i += 4) {
	            j =
	                (msg.charCodeAt(i) << 24) |
	                    (msg.charCodeAt(i + 1) << 16) |
	                    (msg.charCodeAt(i + 2) << 8) |
	                    msg.charCodeAt(i + 3);
	            word_array.push(j);
	        }
	        switch (msg_len % 4) {
	            case 0:
	                i = 0x080000000;
	                break;
	            case 1:
	                i = (msg.charCodeAt(msg_len - 1) << 24) | 0x0800000;
	                break;
	            case 2:
	                i =
	                    (msg.charCodeAt(msg_len - 2) << 24) |
	                        (msg.charCodeAt(msg_len - 1) << 16) |
	                        0x08000;
	                break;
	            case 3:
	                i =
	                    (msg.charCodeAt(msg_len - 3) << 24) |
	                        (msg.charCodeAt(msg_len - 2) << 16) |
	                        (msg.charCodeAt(msg_len - 1) << 8) |
	                        0x80;
	                break;
	        }
	        word_array.push(i);
	        while (word_array.length % 16 != 14)
	            word_array.push(0);
	        word_array.push(msg_len >>> 29);
	        word_array.push((msg_len << 3) & 0x0ffffffff);
	        for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
	            for (i = 0; i < 16; i++)
	                W[i] = word_array[blockstart + i];
	            for (i = 16; i <= 79; i++)
	                W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
	            A = H0;
	            B = H1;
	            C = H2;
	            D = H3;
	            E = H4;
	            for (i = 0; i <= 19; i++) {
	                temp =
	                    (rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5a827999) &
	                        0x0ffffffff;
	                E = D;
	                D = C;
	                C = rotate_left(B, 30);
	                B = A;
	                A = temp;
	            }
	            for (i = 20; i <= 39; i++) {
	                temp =
	                    (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) &
	                        0x0ffffffff;
	                E = D;
	                D = C;
	                C = rotate_left(B, 30);
	                B = A;
	                A = temp;
	            }
	            for (i = 40; i <= 59; i++) {
	                temp =
	                    (rotate_left(A, 5) +
	                        ((B & C) | (B & D) | (C & D)) +
	                        E +
	                        W[i] +
	                        0x8f1bbcdc) &
	                        0x0ffffffff;
	                E = D;
	                D = C;
	                C = rotate_left(B, 30);
	                B = A;
	                A = temp;
	            }
	            for (i = 60; i <= 79; i++) {
	                temp =
	                    (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) &
	                        0x0ffffffff;
	                E = D;
	                D = C;
	                C = rotate_left(B, 30);
	                B = A;
	                A = temp;
	            }
	            H0 = (H0 + A) & 0x0ffffffff;
	            H1 = (H1 + B) & 0x0ffffffff;
	            H2 = (H2 + C) & 0x0ffffffff;
	            H3 = (H3 + D) & 0x0ffffffff;
	            H4 = (H4 + E) & 0x0ffffffff;
	        }
	        temp = cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);
	        return temp.toLowerCase();
	    };
	    NavigateComponent.prototype.myAisToken = function () {
	        if (this.userData) {
	            var randomChar = Math.random().toString(36).substr(2, 4);
	            var firstConvert = this.SHA1('a#BAC@21' + randomChar);
	            this.myaisToken = randomChar.concat(firstConvert);
	            if (config_1.devEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://myais.vas.dev.nascorp.vn/loginservice/" + this.myaisToken);
	            }
	            else if (config_1.testEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://myais.eca.test.nascorp.vn/loginservice/" + this.myaisToken);
	            }
	            else if (config_1.stagingEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://uat-myais.aisvietnam.com/loginservice/" + this.myaisToken);
	            }
	            else if (config_1.procEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://myais.vn/loginservice/" + this.myaisToken);
	            }
	            else if (config_1.localEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://myais.vas.dev.nascorp.vn/loginservice/" + this.myaisToken);
	            }
	            else if (config_1.demoEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://myais.demo.nascorp.vn/loginservice/" + this.myaisToken);
	            }
	        }
	        else {
	            // Redirect to desired URL
	            if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.devEnv.services);
	            }
	            else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.testEnv.services);
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "https://" + config_1.stagingEnv.services);
	            }
	            else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "https://" + config_1.procEnv.services);
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.demoEnv.services);
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.bisHanoiEnv.services);
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.bisHanoiDevEnv.services);
	            }
	            else if (Object.values(config_1.ishcmcEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.ishcmcEnv.services);
	            }
	            else if (Object.values(config_1.aavnIshcmcEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.aavnIshcmcEnv.services);
	            }
	            else if (Object.values(config_1.primaryIshcmcEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.primaryIshcmcEnv.services);
	            }
	            else if (Object.values(config_1.secondaryIshcmcEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.secondaryIshcmcEnv.services);
	            }
	            else if (Object.values(config_1.isspEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.isspEnv.services);
	            }
	            else if (Object.values(config_1.demoHelenEnv).indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://" + config_1.demoHelenEnv.services);
	            }
	            else {
	                return (window.location.href = "http://" + config_1.localEnv.services);
	            }
	        }
	    };
	    NavigateComponent.prototype.toHandbook = function () {
	        window.open('http://www.aisvietnam.com/wp-content/Parent%20Handbook%202018-2019.pdf', '_blank');
	    };
	    NavigateComponent.prototype.toReen = function () {
	        switch (this.hostName) {
	            case config_1.procEnv.auth:
	                window.location.href = "https://" + config_1.procEnv.reen + "/reen/admin/";
	                break;
	            case config_1.devEnv.auth:
	                window.location.href = "http://" + config_1.devEnv.reen + "/reen/admin/";
	                break;
	            case config_1.testEnv.auth:
	                window.location.href = "http://" + config_1.testEnv.reen + "/reen/admin/";
	                break;
	            case config_1.bisHanoiEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiEnv.reen + "/reen/admin/";
	                break;
	            case config_1.bisHanoiDevEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.reen + "/reen/admin/";
	                break;
	            case config_1.bisHanoiStagingEnv.auth:
	                window.location.href = "http://" + config_1.bisHanoiStagingEnv.reen + "/reen/admin/";
	                break;
	            case config_1.ishcmcEnv.auth:
	                window.location.href = "http://" + config_1.ishcmcEnv.reen + "/reen/admin/";
	                break;
	            case config_1.aavnIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.aavnIshcmcEnv.reen + "/reen/admin/";
	                break;
	            case config_1.primaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.primaryIshcmcEnv.reen + "/reen/admin/";
	                break;
	            case config_1.secondaryIshcmcEnv.auth:
	                window.location.href = "http://" + config_1.secondaryIshcmcEnv.reen + "/reen/admin/";
	                break;
	            case config_1.isspEnv.auth:
	                window.location.href = "http://" + config_1.isspEnv.reen + "/reen/admin/";
	                break;
	            case config_1.demoHelenEnv.auth:
	                window.location.href = "http://" + config_1.demoHelenEnv.reen + "/reen/admin/";
	                break;
	            case config_1.stagingEnv.auth:
	                window.location.href = "https://" + config_1.stagingEnv.reen + "/reen/admin/";
	                break;
	            case config_1.demoEnv.auth:
	                window.location.href = "http://" + config_1.demoEnv.reen + "/reen/admin/";
	                break;
	            default:
	                window.location.href = "http://" + config_1.localEnv.reen + "/reen/admin/";
	                break;
	        }
	    };
	    return NavigateComponent;
	}());
	NavigateComponent = __decorate([
	    core_1.Component({
	        selector: 'navigate-page',
	        template: __webpack_require__(247),
	        styles: [__webpack_require__(248)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        UserService_1.UserService,
	        SessionService_1.SessionService,
	        AdminService_1.AdminService])
	], NavigateComponent);
	exports.NavigateComponent = NavigateComponent;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1 class=\"title\">PLEASE SELECT</h1>\n    </div>\n    <div class=\"component-content\">\n        <ul class=\"row\" *ngIf=\"role  === 'system' || role  === 'manager'\">\n            <!-- <li (click)=\"toAsa()\">\n                <span>ASA MANAGEMENT</span>\n            </li>\n            <li (click)=\"toHoliday()\">\n                <span>HOLIDAY MANAGEMENT</span>\n            </li> -->\n            <li style=\"min-width:284px;flex:unset\" (click)=\"toBus()\">\n                <span>BUS MANAGEMENT</span>\n            </li>\n            <!-- <li (click)=\"toMyAis()\">\n                <span>MY VAS</span>\n            </li> -->\n            <!-- <li (click)=\"toCamp()\">\n                <span>CAMP MANAGEMENT</span>\n            </li> -->\n            <!-- <li (click)=\"toHandbook()\">\n                <span>PARENT HANDBOOK</span>\n            </li> -->\n        </ul>\n        <!-- <ul class=\"row\" class=\"custom-navigate\">\n            <li (click)=\"toReen()\">\n                <span>RE-ENROLMENT</span>\n            </li>\n            <li (click)=\"toConferenceBooking()\">\n                <span>PARENT BOOKING</span>\n\t\t\t</li>\n            <li (click)=\"toAccessControl()\" *ngIf=\"role  === 'system'\">\n\t\t\t\t<span>ACCESS CONTROL</span>\n            </li>\n            <li (click)=\"toParentMeeting()\">\n                <span>PARENT MEETING</span>\n            </li>\n\n            <li (click)=\"toAnnouncementsManagement()\">\n                <span>ANNOUNCEMENTS MANAGEMENT</span>\n            </li>\n\n            <li (click)=\"toChatHistory()\">\n              <span>CHAT HISTORY</span>\n            </li>\n            <li (click)=\"toEnrolment()\">\n                <span>ENROLMENT</span>\n            </li>\n        </ul> -->\n        <!-- <ul class=\"row\" *ngIf=\"role === 'student'\" class=\"student-navigate\">\n            <li class=\"large-2\" (click)=\"toMyAis()\">\n                <span>MY VAS</span>\n            </li>\n        </ul> -->\n    </div>\n</div>";

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	module.exports = ".eca-background{background-size:100% 100%}#user-login-component{height:100%;padding:1rem}#user-login-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-login-component .component-title .title{color:#fff}#user-login-component .component-content{margin:3rem auto;width:100%}#user-login-component .component-content ul{text-align:center;display:flex}#user-login-component .component-content ul li{list-style:none;display:block;padding:2rem;background:#fff;border-radius:5px;font-size:0.875rem;font-weight:500;margin:0.5rem;opacity:1;color:#00707e;cursor:pointer;flex:1}.student-navigate li{margin:0 auto !important}.custom-navigate{justify-content:center}.custom-navigate li{max-width:250px}\n"

/***/ })
]);


// WEBPACK FOOTER //
// app.bd17441af37f10adb3cf.js